<template>
    <div class="jump-warphd nav-bar-fixed" style="background-color: #f7f7f7;margin-bottom: 0px!important;">
        <van-nav-bar title="审批详情" left-arrow fixed
                     @click-left="back"/>

        <van-tabs v-model="tabActive" class="appr-tabs">
            <van-tab title="订单信息">
                <order-info></order-info>
                <!--<goods-info :jamubiao="erp.jamubiao" :jmb="jmb.popShow" style="display: none"></goods-info>-->
            </van-tab>
            <van-tab title="商品信息">
                <goods-info :jamubiao="erp.jamubiao" :jmb="jmb.popShow" v-on:sumPrice="handlesumPrice"
                            v-on:outGoodCode="handleoutGoodCode"></goods-info>
            </van-tab>
            <van-tab title="支付发运">
                <div class="pay-by">
                    <div class="appr-item">
                        <van-row class="appr-item-head">
                            <van-col span="12" class="appr-item-head-hd">
                                <h5>
                                    <van-icon name="edit"/>
                                    审批信息流
                                </h5>
                            </van-col>
                            <van-col span="12">
                                <p class="item-r"></p>
                            </van-col>
                        </van-row>
                        <van-row>
                            <van-col span="24">
                                <p><span>申请人</span>{{milkdeductamount.userName}}</p>
                                <p><span>审批类型</span>{{workFlow.workFlowTypeName}}</p>
                                <p><span>申请时间</span>{{order.createtime}}</p>
                                <p><span>停滞时间</span>{{workFlow.deadTime}}</p>
                                <p v-if="!data.checkDelay || actionStatus=='false'">
                                    <van-field
                                            v-model="workFlowTypeName"
                                            readonly
                                            label="审批延迟原因"
                                            placeholder="请选择审批延迟原因"
                                            @focus="showPop"
                                            style="margin-left: -10px;padding-left: 11px;"
                                    />
                                    <van-popup v-model="popShow" position="bottom" :overlay="true">
                                        <van-picker
                                                :columns="columns"
                                                show-toolbar
                                                value-key="dictdata_value"
                                                @cancel="onPickerCancel"
                                                @confirm="onPickerConfirm"
                                                @change="onPickerChange"
                                        />
                                    </van-popup>

                                </p>

                            </van-col>
                        </van-row>

                        <van-row v-if="actionStatus=='false'">
                            <van-col span="8" style="margin-top: 10px"
                                     v-if="data.flag && workFlow.workflowType == 2 && order.isPartOut != 1&& data.isSuBmAudit">
                                <van-button type="info" size="small" class="danger" @click="changeToBatchOut">超市分批
                                </van-button>
                            </van-col>
                        </van-row>

                        <van-row v-if="actionStatus=='false'">
                            <van-col span="10" style="margin-top: 10px"
                                     v-if="data.flag  && data.isWmFstCPAudit && order.orderGoodsType == 3 && order.isPartOut != 1">
                                <van-button type="info" size="small" class="danger" @click="changeWorkFlowType">
                                    变更为非入库流程
                                </van-button>
                            </van-col>

                            <van-col span="8" style="margin-top: 10px;margin-left: 10px"
                                     v-if="data.flag  && (data.isWmFstCPAudit || data.isTmFstNotinAudit || data.isTmDealOne) && (order.orderGoodsType == 2 || order.orderGoodsType == 3 ||order.orderGoodsType == 4 || workFlow.workflowType == 10) && order.isPartOut != 1">
                                <van-button type="info" size="small" class="danger" @click="changeToBatchOut"
                                            v-if="!data.isConfirm">分批出库
                                </van-button>
                            </van-col>
                        </van-row>
                    </div>

                    <van-collapse v-model="activeNames" class="pay-hd-item">
                        <van-collapse-item title="审批日志" name="6">

                            <!-- v-for="item in workflowLog"-->
                            <div v-for="item in workflowLog">
                                <div class="pay-item ok" v-if="item.status">
                                    <van-row>
                                        <van-col span="12">
                                            <p>{{item.createtime}}</p>
                                        </van-col>
                                        <van-col span="12" class="text-center">
                                            <p>{{item.cost_time}}</p>
                                        </van-col>
                                        <!--<van-col span="6">
                                            <p class="pay-state">{{item.remark}} <i class="icon-dian"></i></p>
                                        </van-col>-->
                                    </van-row>
                                    <van-row class="pay-item-ft">
                                        <van-col span="24">
                                            <p>{{item.remark}}</p>
                                        </van-col>
                                        <van-col span="24" class="text-right">
                                            <p><span>审批人：</span>{{item.trueName}}</p>
                                            <p><span>审批状态：</span>{{item.status_name}}</p>
                                        </van-col>
                                    </van-row>
                                    <div class="pay-item-rd"></div>
                                </div>
                                <div class="pay-item err" v-if="!item.status">
                                    <van-row>
                                        <van-col span="6">
                                            <p>{{item.createtime}}</p>
                                        </van-col>
                                        <van-col span="12" class="text-center">
                                            <p>{{item.cost_time}}</p>
                                        </van-col>
                                        <van-col span="6">
                                            <p class="pay-state">{{item.status_name}} <i class="icon-dian"></i></p>
                                        </van-col>
                                    </van-row>
                                    <van-row class="pay-item-ft">
                                        <van-col span="12">
                                            <p>{{item.remark}}</p>
                                        </van-col>
                                        <van-col span="12" class="text-right">
                                            <p><span>审批人:</span>{{item.trueName}}</p>
                                        </van-col>
                                    </van-row>
                                    <div class="pay-item-rd"></div>
                                </div>
                            </div>
                        </van-collapse-item>
                    </van-collapse>
                </div>


                <van-collapse v-model="activeNames" class="pay-hd-item">
                    <van-collapse-item title="订单日志" name="11">
                        <div class="appr-item">
                            <van-row>
                                <van-col span="24" v-for="log in orderLogs" style="border-bottom:1px solid  gray;">
                                    <p><span>操作人：{{log.logUserName}}</span></p>
                                    <p><span>操作时间：{{log.createtime}}</span></p>
                                    <p><span>操作内容：{{log.logInfo}}</span></p>
                                </van-col>

                            </van-row>
                        </div>
                    </van-collapse-item>
                </van-collapse>


                <van-radio-group v-model="radio">
                    <van-cell-group v-for="dd in milkdeductamount.milkShopList">
                        <van-cell v-bind:title="dd.orgName" clickable @click="radio = dd.orgCode">
                            <van-radio :name="dd.orgCode"/>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
                <van-row v-if="actionStatus=='false'&&order.isPartOut!=1">
                    <van-collapse v-model="activeName" class="pay-hd-item"
                                  v-if="(order.isPartOut!=1 && data.isSynErp && (data.isTmSedNotinAudit || data.isSuBmAudit || data.isWmFstCPAudit))|| (data.isWmFstCPAudit && workFlow.workflowType != 4 && order.isPartOut != 1) && userRole!='RM' || data.isTmDealTwo || data.isSuBmAudit">
                        <van-collapse-item icon="edit" title="订单类型及发货信息" name="2">
                            <div class="pay-hd-line">
                                <van-cell title="是否对接ERP">
                                    <van-switch v-model="erp.isErp" @change="changeSynErp"/>
                                </van-cell>
                                <van-row v-if="changeSynErps">
                                    <van-cell title="赠品是否同步ERP" v-if="data.isPromotionGiveOrder">
                                        <van-switch v-model="erp.isPromotionGiveOrder"/>
                                    </van-cell>


                                    <van-cell title="使用价目表价格">
                                        <van-switch v-model="erp.jamubiao" @change="syjmb"/>
                                    </van-cell>


                                    <van-field
                                            v-model="erp.entityValue"
                                            readonly
                                            label="业务实体"
                                            placeholder="请选择"
                                            @focus="entityShow"
                                    />

                                    <van-popup v-model="erp.entityPopShow" position="bottom" :overlay="true">
                                        <van-picker
                                                :columns="erp.entityColumns"
                                                show-toolbar
                                                value-key="ouName"
                                                @cancel="entityCancel"
                                                @confirm="entityConfirm"
                                                @change="entityChange"
                                        />
                                    </van-popup>

                                    <van-row v-if="orgIndex==2">
                                        <van-field
                                                v-model="org.value"
                                                readonly
                                                label="业务库"
                                                placeholder="请选择"
                                                @focus="orgShow"
                                        />

                                        <van-popup v-model="org.popShow" position="bottom" :overlay="true">
                                            <van-picker
                                                    :columns="org.columns"
                                                    show-toolbar
                                                    value-key="organizationName"
                                                    @cancel="orgCancel"
                                                    @confirm="orgConfirm"
                                                    @change="orgChange"
                                            />
                                        </van-popup>
                                    </van-row>
                                </van-row>

                            </div>
                            <div class="pay-hd-line" v-if="changeSynErps">
                                <van-field
                                       v-if="workFlow.workflowType!=2"
                                        v-model="dec.value"
                                        readonly
                                        label="发运方式"
                                        placeholder="请选择"
                                        @focus="decShow"
                                />
                                <van-popup v-model="dec.popShow" position="bottom" :overlay="true">
                                    <van-picker
                                            :columns="dec.columns"
                                            show-toolbar
                                            value-key="shipMethodMeaning"
                                            @cancel="decCancel"
                                            @confirm="decConfirm"
                                            @change="decChange"
                                    />
                                </van-popup>

                                <van-field
                                        v-if="workFlow.workflowType!=2"
                                        v-model="sec.value"
                                        readonly
                                        label="承运人"
                                        placeholder="请选择"
                                        @focus="secShow"
                                />
                                <van-popup v-model="sec.popShow" position="bottom" :overlay="true">
                                    <van-picker
                                            :columns="sec.columns"
                                            show-toolbar
                                            value-key="carrierName"
                                            @cancel="secCancel"
                                            @confirm="secConfirm"
                                            @change="secChange"
                                    />
                                </van-popup>

                                <van-field
                                        v-model="odt.value"
                                        readonly
                                        label="订单类型"
                                        placeholder="请选择"
                                        @focus="odtShow"
                                />
                                <van-popup v-model="odt.popShow" position="bottom" :overlay="true">
                                    <van-picker
                                            :columns="odt.columns"
                                            show-toolbar
                                            value-key="orderTypeName"
                                            @cancel="odtCancel"
                                            @confirm="odtConfirm"
                                            @change="odtChange"
                                    />
                                </van-popup>

                                <van-field
                                        v-model="jmb.value"
                                        readonly
                                        label="价目表"
                                        placeholder="请选择"
                                        @focus="jmbShow"
                                />
                                <van-popup v-model="jmb.popShow" position="bottom" :overlay="true">
                                    <van-picker
                                            :columns="jmb.columns"
                                            show-toolbar
                                            value-key="name"
                                            @cancel="jmbCancel"
                                            @confirm="jmbConfirm"
                                            @change="jmbChange"
                                    />
                                </van-popup>

                                <van-field
                                        v-model="ptm.value"
                                        readonly
                                        label="付款条件"
                                        placeholder="请选择"
                                        @focus="ptmShow"
                                />
                                <van-popup v-model="ptm.popShow" position="bottom" :overlay="true">
                                    <van-picker
                                            :columns="ptm.columns"
                                            show-toolbar
                                            value-key="name"
                                            @cancel="ptmCancel"
                                            @confirm="ptmConfirm"
                                            @change="ptmChange"
                                    />
                                </van-popup>

                                <van-field
                                        v-model="ywy.value"
                                        readonly
                                        label="业务员编码"
                                        placeholder="请选择"
                                        @focus="ywyShow"
                                />
                                <van-popup v-model="ywy.popShow" position="bottom" :overlay="true">
                                    <van-picker
                                            :columns="ywy.columns"
                                            show-toolbar
                                            @cancel="ywyCancel"
                                            @confirm="ywyConfirm"
                                            @change="ywyChange"
                                    />
                                </van-popup>
                                <van-row v-if="workFlow.workflowType!=2">
                                <van-radio-group v-model="sourceTypeCode"
                                                 v-if="data.isSuBmAudit ||workFlow.workflowType==4||workFlow.workflowType==10">
                                    <van-cell-group>
                                        <van-cell title="销转采订单">
                                            <van-radio name="INTERNAL" style="float: left">否</van-radio>
                                            <van-radio name="EXTERNAL" style="float: left">是</van-radio>
                                        </van-cell>
                                    </van-cell-group>
                                </van-radio-group>
                                </van-row>
                            </div>
                            <!--data.isTmFstNotinAudit || data.isWmFstCPAudit ||   入库原料第一次审批发车信息显示两次（isWmFstCPAudit） -->
                            <van-row v-if="  data.isSuBmAudit  ">
                                <van-cell title="用户选择自提" v-if=" order.transport=='自提'"
                                          style="color: red;font-size: 12px"/>
                                <van-row
                                        v-if="(changeShow || order.transport!='自提')|| (data.isWmFstCPAudit && order.transport!='自提') || data.isTmFstNotinAudit">
                                    <van-radio-group v-model="chetype">
                                        <van-cell-group>
                                            <van-cell title="车次安排">
                                                <van-radio name="1" style="float: left">专车</van-radio>
                                                <van-radio name="2" style="float: left">拼车</van-radio>
                                            </van-cell>
                                        </van-cell-group>
                                    </van-radio-group>

                                    <van-cell-group>
                                        <van-field
                                                v-model="cheCode"
                                                label="车牌号"
                                                placeholder="请输入车牌号"
                                                @blur="getPhone"
                                        />

                                        <van-field
                                                v-model="phone"
                                                label="司机手机号"
                                                placeholder="请输入司机手机号"
                                        />
                                    </van-cell-group>

                                    <van-field
                                            v-model="birthday"
                                            label="发车时间"
                                            placeholder="请选择"
                                            @focus="showDate"
                                            readonly
                                    />

                                    <van-field
                                            v-model="driverName"
                                            label="司机姓名"
                                            placeholder="请输入司机姓名"
                                    />
                                    <van-field
                                            v-model="driverIdnumber"
                                            label="司机身份证号"
                                            placeholder="请输入司机身份证号"
                                    />

                                    <van-cell title="快捷录入"/>
                                    <van                                                                                                                                                                                                                                                                                        -field type="textarea" @blur="getspeedy_input" v-model="speedy_input"
                                               placeholder="请输入快捷录入信息(逗号分隔)"/>

                                    <van-popup v-model="popDateShow" position="bottom" :overlay="true">
                                        <van-datetime-picker
                                                v-model="currentDate"
                                                type="datetime"
                                                @cancel="popDateShow = false"
                                                @confirm="onDateConfirm"

                                        />
                                    </van-popup>

                                </van-row>
                            </van-row>

                            <van-cell title="发货补充信息"/>
                            <van-field type="textarea" v-model="fhInfo" placeholder="请输入发货补充信息"/>
                        </van-collapse-item>
                    </van-collapse>
                </van-row>

                <van-row>
                    <van-col span="8" style="margin: 10px" v-if="order.isPartOut==1&&data.hasDelivery">
                        <van-button type="info" size="normal" class="blues" @click="viewDelivery">查看出库单
                        </van-button>
                    </van-col>
                    <van-col span="10" style="margin-top: 10px"
                             v-if="data.isShowModifyPlan&&(userRole.indexOf('BM')>-1||userRole.indexOf('TM')>-1)">
                        <van-button type="info" size="normal" class="blues" @click="deliveryGoodPlanSow(2)">
                            查看发运计划
                        </van-button>
                    </van-col>
                </van-row>

                <van-collapse v-model="activeNames" class="pay-hd-item" v-if="userRole!='RM' && order.payClass==3">
                    <van-collapse-item icon="info-o" title="奶款信息" name="3">
                        <van-cell title="奶量存量（公斤）" :value="milkdeductamount.milksystem_milk_amount"/>
                        <van-cell title="奶价（元/公斤）" :value="milkdeductamount.milk_price"/>
                        <van-cell title="银行还款信息（元/每月)" :value="milkdeductamount.repayment_money_month"/>
                        <van-cell title="其他扣款（元）" :value="milkdeductamount.other_deduct_amount"/>
                        <van-cell title="本月累计扣减奶款（元）" :value="milkdeductamount.deducted_milk_money_amount"/>
                        <van-cell title=" 累计预扣奶款（元）" :value="milkdeductamount.deducted_before_milk_money_amount"/>
                        <van-cell title="上月奶款结余（元）" :value="milkdeductamount.last_month_remain"/>
                        <van-cell title="奶款安全系数" :value="milkdeductamount.milk_safty_factor"/>
                        <van-cell title="奶款结余（元）" :value="milkdeductamount.milk_remain"/>
                        <van-row v-if="actionStatus=='true'">
                            <van-cell title="本次订单扣减奶款（元）" :value="order.realPrice"/>
                        </van-row>
                        <van-row v-else>
                            <van-cell title="本次订单扣减奶款（元）" :value="sumPrice | numFilter"
                                      v-if="data.isTmSedNotinAudit ||  data.isSuBmAudit|| data.isWmSedCPAudit ||data.isTmDealTwo"/>
                        </van-row>
                        <van-cell title="预扣奶款（元）" :value="calculationPrice  | numFilter"
                                  v-if="workFlow.workflowType!=1 && workFlow.workflowType!=5  && workFlow.roleDeal=='BM'"/>
                    </van-collapse-item>
                </van-collapse>
                <van-collapse v-model="activeNames" class="pay-hd-item" v-if="order.isPartOut!=1&&orderErpinfos.length>0">
                    <van-collapse-item icon="info-o" title="ERP信息" name="4">
                        <van-row v-for="item in orderErpinfos">
                            <!--<van-cell title="业务实体" :value="item.cuxOuName"/>
                            <van-cell title="库存组织）" :value="item.warehouseName"/>
                            <van-cell title="订单类型" :value="item.businessTypeName"/>
                            <van-cell title="付款条件" :value="item.paymentTermName"/>
                            <van-cell title="价目表"
                                      :value="item.sourceTypeCode=='EXTERNAL'?item.priceListName+'（销转采）':item.priceListName"/>
                            <van-cell title="是否为退货" :value="item.orderType=='RETURN'?'退货':item.givedOrder?'赠送':'销售单'"/>
                            <van-cell title="退货原因" :value="item.returnReasonDes"/>-->
                            <van-row>
                                <span style="color: #323233;font-size: 14px;">业务实体</span>
                            </van-row>
                            <van-row>{{item.cuxOuName}}</van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">库存组织</span>
                            </van-row>
                            <van-row>{{item.warehouseName}}</van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">订单类型</span>
                            </van-row>
                            <van-row>{{item.businessTypeName}}</van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">付款条件</span>
                            </van-row>
                            <van-row>{{item.paymentTermName}}</van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">价目表</span>
                            </van-row>
                            <van-row>{{item.sourceTypeCode=='EXTERNAL'?item.priceListName+'（销转采）':item.priceListName}}
                            </van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">是否为退货</span>
                            </van-row>
                            <van-row>{{item.orderType=='RETURN'?'退货':item.givedOrder?'赠送':'销售单'}}</van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">退货原因</span>
                            </van-row>
                            <van-row>{{item.returnReasonDes}}</van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">同步ERP状态</span>
                            </van-row>
                            <van-row>
                                <a style="color: #007bff;" @click="showErpInfo(item)">查看</a>
                            </van-row>

                            <van-row style="margin-top: 20px;">
                                <span style="color: #323233;font-size: 14px;">赠品是否同步ERP</span>
                            </van-row>
                            <van-row>{{item.synGiftErp==0?'否':item.synGiftErp==1?'是':''}}</van-row>

                            <!-- <van-cell title="赠品是否同步ERP" :value="item.lastMonthRemain"/>-->
                        </van-row>
                    </van-collapse-item>
                </van-collapse>

                <van-row
                        v-if="workFlow.roleDeal=='FM' && orderPayLogs.pay_class==3 &&workFlow.workflowType != 5 && actionStatus=='false'">
                    <van-col span="24">
                        <p style="margin-left: 15px"><span>订单金额：</span>{{data.calculationPrice}}</p>
                        <p>
                            <van-cell-group>
                                <van-field
                                        v-model="tempQuota"
                                        label="授信额度"
                                />
                            </van-cell-group>
                        </p>
                        <p style="margin-left: 15px"><span>用户可用奶款额度：</span>{{milkdeductamount.milk_remain}}</p>
                    </van-col>
                </van-row>

                <van-row
                        v-if="actionStatus=='false' &&workFlow.workflowType == 5 && data.flag && data.isSynErp && data.jmOrderErpinfo && userRole.indexOf('FM')>-1">
                    <van-col span="24">
                        <van-cell title="是否对接ERP">
                            <van-switch v-model="fefund.isErp"/>
                        </van-cell>

                        <van-field
                                v-model="fefund.value"
                                readonly
                                label="订单类型"
                                placeholder="请选择"
                                @focus="fefundShow"
                        />
                        <van-popup v-model="fefund.popShow" position="bottom" :overlay="true">
                            <van-picker
                                    :columns="fefund.columns"
                                    show-toolbar
                                    value-key="orderTypeName"
                                    @cancel="fefundCancel"
                                    @confirm="fefundtConfirm"
                                    @change="fefundChange"
                            />
                        </van-popup>

                        <van-field
                                v-model="fefund.valued"
                                readonly
                                label="退货原因"
                                placeholder="请选择"
                                @focus="fefundShowd"
                        />
                        <van-popup v-model="fefund.popShowd" position="bottom" :overlay="true">
                            <van-picker
                                    :columns="fefund.columnsd"
                                    show-toolbar
                                    value-key="meaning"
                                    @cancel="fefundCanceld"
                                    @confirm="fefundtConfirmd"
                                    @change="fefundChanged"
                            />
                        </van-popup>
                    </van-col>
                </van-row>

                <van-collapse v-model="activeNames" class="pay-hd-item"
                              v-if="milkDeductLog!=null && milkDeductLog.length!=0">
                    <van-collapse-item title="财务录入会员奶款信息" name="12">
                        <div class="appr-item">
                            <van-row>
                                <van-col span="24" v-for="log in milkDeductLog" style="border-bottom:1px solid  gray;">
                                    <p><span>奶量存量：{{log.milkAmount}}</span></p>
                                    <p><span>奶价：{{log.milkPrice}}</span></p>
                                    <p><span>银行还款信息：{{log.repaymentMoneyMonth}}</span></p>
                                    <p><span>其他扣款：{{log.otherDeductAmount}}</span></p>
                                    <p><span>本月累计扣减奶款：{{log.totalDeductMilkMoneyAmount}}</span></p>
                                    <p><span>上月奶款结余：{{log.lastMonthRemain}}</span></p>
                                    <p><span>锁定奶款：{{log.deductedBeforeMilkMoneyAmount}}</span></p>
                                    <p><span>奶款结余：{{log.milkRemain}}</span></p>
                                    <p><span>本次扣减奶款：{{log.deductMilkMoneyAmount}}</span></p>
                                </van-col>

                            </van-row>
                        </div>
                    </van-collapse-item>
                </van-collapse>

                <van-collapse v-model="activeNames" v-if="workflowFileList.length>0">
                    <van-collapse-item title="附件清单" name="1">
                        <van-cell-group v-for="obj in workflowFileList" style="border:5px solid  #f8f8f8">
                            <div @click="picimg(obj.fileUrl)">
                                <van-cell title="标题" :value="obj.title"/>
                                <van-cell title="上传人" :value="obj.userName"/>
                                <van-cell title="上传时间" :value="obj.createtime"/>
                            </div>
                        </van-cell-group>
                        <van-dialog
                                v-model="picimgeshow"
                        >
                            <img :src="picimgUrl" style="width:100%; height:auto;">
                        </van-dialog>
                    </van-collapse-item>
                </van-collapse>

                <van-collapse v-model="activeNames" v-if="shipmentInfoLog.length>0">
                    <van-collapse-item title="发货信息变更日志" name="2">
                        <van-cell-group v-for="obj in shipmentInfoLog" style="border:5px solid  #f8f8f8">
                            <div>
                                <van-cell title="车辆类型" :value="obj.trainType==1?'专车':'拼车'"/>
                                <van-cell title="司机手机号" :value="obj.mobileDriver"/>
                                <van-cell title="司机车牌号" :value="obj.plateNo"/>
                                <van-cell title="发车时间" :value="obj.departureTime"/>
                                <van-cell title="司机姓名" :value="obj.driverName"/>
                                <van-cell title="司机身份证号" :value="obj.driverIdnumber"/>
                            </div>
                        </van-cell-group>
                    </van-collapse-item>
                </van-collapse>

                <van-row style="background-color: #fff;" v-if="actionStatus=='false'">

                    <van-col span="24" v-if="data.isBmDealTwo">
                        <van-uploader :after-read="onRead">
                            <van-field label="过磅单" readonly placeholder="请上传过磅单"/>
                        </van-uploader>
                    </van-col>
                    <van-row v-if="data.isBmDealTwo">
                        <van-col span="8" v-for="pic in urlList">
                            <div>
                                <span class="delete" @click="deImge(pic.id)">×</span>
                                <img :src="pic.fileUrl"
                                     style="width:100%; height:102px;">
                            </div>
                        </van-col>
                    </van-row>
                    <!--<van-col span="24" v-if="data.isBmDealTwo">
                        <van-button size="small" type="primary" style="margin-left: 10px"
                                    @click="seeImge">查看图片
                        </van-button>
                        <van-button size="small" type="primary" style="margin-left: 10px"
                                    @click="deImge">删除
                        </van-button>
                        <van-dialog
                                v-model="imgeshow"
                        >
                            <img :src="imgUrl" style="width:100%; height:auto;">
                        </van-dialog>
                    </van-col>-->
                </van-row>
                <!--非入库审批 贸易第一次 显示发运信息 936 -->
                <van-row
                        v-if="!(data.isTmFstNotinAudit && actionStatus=='false' && order.transport!='自提'&&order.isPartOut!=1)&&(actionStatus=='false'&&order.isPartOut!=1 && !data.isConfirm)">
                    <van-collapse v-model="activeNamess" class="pay-hd-item"
                                  v-if="milkDeductLog!=null && milkDeductLog.length!=0 || data.isTmDealOne ||data.isWmFstCPAudit ||data.isTmFstNotinAudit  || (data.isTmDealOne && !data.multiple) ">
                        <van-collapse-item title="发货信息" name="13">
                            <div class="appr-item">
                                <van-row>
                                    <van-cell title="用户选择自提" v-if=" order.transport=='自提'"
                                              style="color: red;font-size: 12px"/>
                                    <van-row
                                            v-if="(changeShow || order.transport!='自提')|| data.isWmFstCPAudit || data.isTmFstNotinAudit || data.isTmDealOne">
                                        <van-row v-if="data.isTmDealOne">
                                            <van-radio-group v-model="shenhefangshi">
                                            <van-cell-group>
                                                <van-cell title="请选择审核方式">
                                                    <van-radio name="0" style="float: left">自审</van-radio>
                                                    <van-radio name="1" style="float: left">供审</van-radio>
                                                </van-cell>
                                            </van-cell-group>
                                            </van-radio-group>

                                            <van-col span="24" v-if="shenhefangshi==0">
                                                <van-uploader :after-read="onRead">
                                                    <van-field label="发货过磅单" readonly placeholder="请上传发货过磅单"/>
                                                </van-uploader>
                                            </van-col>
                                            <van-row v-if="shenhefangshi==0">
                                                <van-col span="8" v-for="pic in urlList">
                                                    <div>
                                                        <span class="delete" @click="deImge(pic.id)">×</span>
                                                        <img :src="pic.fileUrl"
                                                             style="width:100%; height:102px;">
                                                    </div>
                                                </van-col>
                                            </van-row>
                                            <!--<van-col span="24" v-if="shenhefangshi==0">
                                                <van-button size="small" type="primary" style="margin-left: 10px"
                                                            @click="seeImge">查看图片
                                                </van-button>
                                                <van-button size="small" type="primary" style="margin-left: 10px"
                                                            @click="deImge">删除
                                                </van-button>
                                                <van-dialog
                                                        v-model="imgeshow"
                                                >
                                                    <img :src="imgUrl" style="width:100%; height:auto;">
                                                </van-dialog>
                                            </van-col>-->
                                        </van-row>

                                        <van-row
                                                v-if="( ((order.transport=='自提'||order.transport=='管车宝') && userRole.indexOf('BM')!=-1) || (order.transport=='物流配送'&& userRole.indexOf('TM')!=-1 ) || (workFlow.workflowType==3 &&order.transport=='物流配送'&& userRole.indexOf('BM')!=-1 ))">
                                            <van-row
                                                    v-if="shenhefangshi==0 && order.transport!='管车宝'">
                                                <van-radio-group v-model="chetype">
                                                    <van-cell-group>
                                                        <van-cell title="车次安排">
                                                            <van-radio name="1" style="float: left">专车</van-radio>
                                                            <van-radio name="2" style="float: left">拼车</van-radio>
                                                        </van-cell>
                                                    </van-cell-group>
                                                </van-radio-group>

                                                <van-cell-group>
                                                    <van-field
                                                            v-model="cheCode"
                                                            label="车牌号"
                                                            placeholder="请输入车牌号"
                                                            @blur="getPhone"
                                                    />

                                                    <van-field
                                                            v-model="phone"
                                                            label="司机手机号"
                                                            placeholder="请输入司机手机号"
                                                    />
                                                </van-cell-group>

                                                <van-field
                                                        v-model="birthday"
                                                        label="发车时间"
                                                        placeholder="请选择"
                                                        @focus="showDate"
                                                        readonly
                                                />

                                                <van-field
                                                        v-model="driverName"
                                                        label="司机姓名"
                                                        placeholder="请输入司机姓名"
                                                />
                                                <van-field
                                                        v-model="driverIdnumber"
                                                        label="司机身份证号"
                                                        placeholder="请输入司机身份证号"
                                                />

                                                <van-cell title="快捷录入"/>
                                                <van-field type="textarea" v-model="speedy_input"
                                                           @blur="getspeedy_input"
                                                           placeholder="请输入快捷录入信息(逗号分隔)"/>


                                                <van-popup v-model="popDateShow" position="bottom" :overlay="true">
                                                    <van-datetime-picker
                                                            v-model="currentDate"
                                                            type="datetime"
                                                            @cancel="popDateShow = false"
                                                            @confirm="onDateConfirm"

                                                    />
                                                </van-popup>
                                            </van-row>
                                            <van-row v-else>
                                                <van-field
                                                        :value="order.plateNo"
                                                        label="车牌号"
                                                        readonly
                                                />

                                                <van-field
                                                        :value="order.mobileDriver"
                                                        label="司机手机号"
                                                        readonly
                                                />

                                                <van-field
                                                        :value="order.departureTime"
                                                        label="发车时间"
                                                        readonly
                                                />

                                                <van-field
                                                        v-model="order.driverName"
                                                        label="司机姓名"
                                                        readonly
                                                />
                                                <van-field
                                                        v-model="order.driverIdnumber"
                                                        label="司机身份证号"
                                                        readonly
                                                />


                                            </van-row>
                                        </van-row>
                                    </van-row>
                                </van-row>

                            </div>
                        </van-collapse-item>
                    </van-collapse>
                </van-row>

                <!-- 业务员贸易流程配送方式为管车宝/自提 -->
                <van-row
                        v-if="(order.transport=='自提'||order.transport=='管车宝') && workFlow.workflowType==10 && data.isBmDealOne&&actionStatus=='false'">
                    <van-radio-group v-model="chetype">
                        <van-cell-group>
                            <van-cell title="车次安排">
                                <van-radio name="1" style="float: left">专车</van-radio>
                                <van-radio name="2" style="float: left">拼车</van-radio>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>

                    <van-cell-group>
                        <van-field
                                v-model="cheCode"
                                label="车牌号"
                                placeholder="请输入车牌号"
                                @blur="getPhone"
                        />

                        <van-field
                                v-model="phone"
                                label="司机手机号"
                                placeholder="请输入司机手机号"
                        />
                    </van-cell-group>

                    <van-field
                            v-model="birthday"
                            label="发车时间"
                            placeholder="请选择"
                            @focus="showDate"
                            readonly
                    />
                    <van-field
                            v-model="driverName"
                            label="司机姓名"
                            placeholder="请输入司机姓名"
                    />
                    <van-field
                            v-model="driverIdnumber"
                            label="司机身份证号"
                            placeholder="请输入司机身份证号"
                    />

                    <van-cell title="快捷录入"/>
                    <van-field type="textarea" v-model="speedy_input" @blur="getspeedy_input"
                               placeholder="请输入快捷录入信息(逗号分隔)"/>

                    <van-popup v-model="popDateShow" position="bottom" :overlay="true">
                        <van-datetime-picker
                                v-model="currentDate"
                                type="datetime"
                                @cancel="popDateShow = false"
                                @confirm="onDateConfirm"

                        />
                    </van-popup>
                </van-row>

                <!-- 贸易（物流配送）/业务员修改发货信息（管车宝和自提） (((order.transport=='自提'||order.transport=='管车宝') && userRole.indexOf('BM')!=-1)||(order.transport=='物流配送'&& userRole.indexOf('TM')!=-1 )) && actionStatus=='true'&&workFlow.status==0 -->
                <!-- workFlow.workflowType==10 && actionStatus=='true' 已审核贸易流程 -->
                <van-row
                        v-if="( ((order.transport=='自提'||order.transport=='管车宝') && userRole.indexOf('BM')!=-1) || (order.transport=='物流配送'&& userRole.indexOf('TM')!=-1 )) && (actionStatus=='true'|| actionStatus==true)&&workFlow.workflowType==10&&workFlow.status==0">
                    <van-radio-group v-model="chetype">
                        <van-cell-group>
                            <van-cell title="车次安排">
                                <van-radio name="1" style="float: left">专车</van-radio>
                                <van-radio name="2" style="float: left">拼车</van-radio>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>

                    <van-cell-group>
                        <van-field
                                v-model="cheCode"
                                label="车牌号"
                                placeholder="请输入车牌号"
                                @blur="getPhone"
                        />

                        <van-field
                                v-model="phone"
                                label="司机手机号"
                                placeholder="请输入司机手机号"
                        />
                    </van-cell-group>

                    <van-field
                            v-model="birthday"
                            label="发车时间"
                            placeholder="请选择"
                            @focus="showDate"
                            readonly
                    />
                    <van-field
                            v-model="driverName"
                            label="司机姓名"
                            placeholder="请输入司机姓名"
                    />
                    <van-field
                            v-model="driverIdnumber"
                            label="司机身份证号"
                            placeholder="请输入司机身份证号"
                    />

                    <van-cell title="快捷录入"/>
                    <van-field type="textarea" v-model="speedy_input" @blur="getspeedy_input"
                               placeholder="请输入快捷录入信息(逗号分隔)"/>

                    <van-popup v-model="popDateShow" position="bottom" :overlay="true">
                        <van-datetime-picker
                                v-model="currentDate"
                                type="datetime"
                                @cancel="popDateShow = false"
                                @confirm="onDateConfirm"

                        />
                    </van-popup>
                    <van-col span="8" style="margin: 10px">
                        <van-button type="info" size="large" class="blues" @click="shippingInfoEdit">确定修改
                        </van-button>
                    </van-col>
                </van-row>


                <!-- 贸易修改发货信息（管车宝和自提） (((order.transport=='自提'||order.transport=='管车宝') && userRole.indexOf('TM')!=-1)) && actionStatus=='true'&&workFlow.status==0-->
                <!-- 非入库审批 贸易第一次 显示发运信息 -->
                <van-row
                        v-if="data.isTmFstNotinAudit && actionStatus=='false' && order.transport!='自提'&&order.isPartOut!=1">
                    <van-radio-group v-model="chetype">
                        <van-cell-group>
                            <van-cell title="车次安排">
                                <van-radio name="1" style="float: left">专车</van-radio>
                                <van-radio name="2" style="float: left">拼车</van-radio>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>

                    <van-cell-group>
                        <van-field
                                v-model="cheCode"
                                label="车牌号"
                                placeholder="请输入车牌号"
                                @blur="getPhone"
                        />

                        <van-field
                                v-model="phone"
                                label="司机手机号"
                                placeholder="请输入司机手机号"
                        />
                    </van-cell-group>

                    <van-field
                            v-model="birthday"
                            label="发车时间"
                            placeholder="请选择"
                            @focus="showDate"
                            readonly
                    />
                    <van-field
                            v-model="driverName"
                            label="司机姓名"
                            placeholder="请输入司机姓名"
                    />
                    <van-field
                            v-model="driverIdnumber"
                            label="司机身份证号"
                            placeholder="请输入司机身份证号"
                    />

                    <van-cell title="快捷录入"/>
                    <van-field type="textarea" v-model="speedy_input" @blur="getspeedy_input"
                               placeholder="请输入快捷录入信息(逗号分隔)"/>

                    <van-popup v-model="popDateShow" position="bottom" :overlay="true">
                        <van-datetime-picker
                                v-model="currentDate"
                                type="datetime"
                                @cancel="popDateShow = false"
                                @confirm="onDateConfirm"

                        />
                    </van-popup>
                    <!-- <van-col span="8" style="margin: 10px;">
                         <van-button type="info" size="large" class="blues" @click="shippingInfoEdit">确定修改
                         </van-button>
                     </van-col>-->
                </van-row>

                <div class="appr-item apply" v-if="actionStatus=='false'">
                    <van-row class="appr-item-head">
                        <van-col span="12" class="appr-item-head-hd">
                            <h5>
                                <van-icon name="edit"/>
                                审批意见
                            </h5>
                        </van-col>
                        <van-col span="12">
                            <p class="item-r"></p>
                        </van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24">
                            <van-field type="textarea" v-model="stockremark" placeholder="请输审批意见"/>
                        </van-col>
                        <!--<van-col span="8" style="margin-top: 10px">
                            <van-button type="info" size="large" @click="savedeal(1)">通过</van-button>
                        </van-col>-->
                        <!-- 库管审核 -->
                        <van-row v-if="userRole=='RM'">
                            <van-col span="8" style="margin-top: 10px">
                                <van-button type="info" size="large" class="blues" @click="savedeal(1)">发货
                                </van-button>
                            </van-col>

                            <van-col span="10" style="margin-top: 10px" v-if="!data.isPromotionOrder">
                                <van-button type="info" size="large" class="blues" @click="deliverGoodsNum">设置发货数量
                                </van-button>
                            </van-col>

                        </van-row>
                        <van-row v-else>
                            <van-row v-if="data.isConfirm&&userRole.indexOf('BM')!=-1">
                                <van-col span="8" style="margin-top: 10px">
                                    <van-button type="info" size="large" class="blues" @click="ywybh()">确定
                                    </van-button>
                                </van-col>
                            </van-row>
                            <van-row v-else>
                                <van-col span="8" style="margin-top: 10px"
                                         v-if="workFlow.workflowType==10 && data.isTmDealOne && !data.multiple && order.isPartOut!='1'">
                                    <van-button type="info" size="large" class="blues" @click="savedeal(1)">通过
                                    </van-button>
                                </van-col>

                                <van-col span="8" style="margin-top: 10px"
                                         v-if="(workFlow.workflowType!=10 ||(workFlow.workflowType==10 && !data.isTmDealOne))&&(order.isPartOut!='1' || workFlow.workflowType==5)">
                                    <van-button type="info" size="large" class="blues" @click="savedeal(1)">通过
                                    </van-button>
                                </van-col>


                                <van-col span="9" style="margin-top: 10px"
                                         v-if="(data.isTmFstNotinAudit || data.isTmDealOne) && !data.isPromotionOrder&& order.isPartOut!='1'">
                                    <van-button type="info" size="large" class="blues" @click="deliverGoodsNum">设置发货数量
                                    </van-button>
                                </van-col>

                                <van-col span="8" style="margin-top: 10px"
                                         v-if="(data.isSuBmAudit && order.isPartOut=='1') || (data.isWmFstCPAudit && order.isPartOut=='1' ) || (data.isTmFstNotinAudit && order.isPartOut=='1' ) || (data.isTmDealOne && order.isPartOut=='1' )">
                                    <van-button type="info" size="large" class="blues" @click="depositGood">创建出库单
                                    </van-button>
                                </van-col>

                                <van-col span="8" style="margin-top: 10px"
                                         v-if="(data.isSuBmAudit && order.isPartOut=='1') || (data.isWmFstCPAudit && order.isPartOut=='1' )|| (data.isTmFstNotinAudit && order.isPartOut=='1' )|| (data.isTmDealOne && order.isPartOut=='1' )">
                                    <van-button type="info" size="large" class="blues" @click="setBatchOutComplete">
                                        已全部出库
                                    </van-button>
                                </van-col>

                                <!-- <van-col span="8" style="margin-top: 10px"
                                          v-if="changeShow==false&&data.isSuBmAudit && order.transport=='自提'">
                                     <van-button type="info" size="large" class="blues" @click="changeYouJi">变更为邮寄
                                     </van-button>
                                 </van-col>-->

                                <van-col span="10" style="margin-top: 10px"
                                         v-if="data.isWmFstCPAudit && order.isPartOut=='1' || (data.isTmFstNotinAudit && order.isPartOut=='1' )">
                                    <van-button type="info" size="large" class="blues" @click="orderGoodsGiveSave">
                                        设置商品赠送数
                                    </van-button>
                                </van-col>

                                <van-col span="10" style="margin-top: 10px"
                                         v-if="(workFlow.workflowType==10 && userRole.indexOf('BM')!=-1 && data.isBmDealOne)||data.isBmAuditPayClass3and5">
                                    <van-button type="info" size="large" class="blues" @click="deliveryGoodPlan(1)">
                                        创建分批计划
                                    </van-button>
                                </van-col>

                                <van-col span="10" style="margin-top: 10px;margin-left: 10px"
                                         v-if="data.isWMTMAuditPayClass3and5">
                                    <van-button type="info" size="large" class="blues" @click="deliveryGoodPlan(2)">
                                        查看分批计划
                                    </van-button>
                                </van-col>


                                <van-col span="8" style="margin-top: 10px">
                                    <van-button type="info" size="large" class="danger" @click="savedeal(0)">驳回
                                    </van-button>
                                </van-col>

                            </van-row>
                        </van-row>
                    </van-row>
                </div>
                <div v-if="actionStatus=='true'">
                      <van-col span="10" style="margin-top: 10px"
                                        v-if="(workFlow.workflowType==10 && userRole.indexOf('BM')!=-1 && data.isBmDealOne)||data.isBmAuditPayClass3and5">
                                    <van-button type="info" size="large" class="blues" @click="deliveryGoodPlan(1)">
                                        创建分批计划
                                    </van-button>
                                </van-col>
                                </div>
                <!--<div v-else>
                    <van-col span="8" style="margin: 10px">
                        <van-button type="info" size="large" class="blues" @click="seeIsTrueOrder">查看确认单
                        </van-button>
                    </van-col>
                </div>-->
            </van-tab>
        </van-tabs>

    </div>
</template>
<script>
    import {
        Panel,
        Uploader,
        Button,
        Cell,
        CellGroup,
        Col,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Dialog,
        Field,
        NavBar,
        Picker,
        Popup,
        Radio,
        RadioGroup,
        Row,
        Switch,
        Tab,
        Tabs
    } from "vant";
    import OrderInfo from '../../components/OrderInfo';
    import GoodsInfo from '../../components/GoodsInfo';

    export default {
        name: "ApprovalDetail",
        components: {
            [Panel.name]: Panel,
            [Dialog.name]: Dialog,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Uploader.name]: Uploader,
            [Switch.name]: Switch,
            'order-info': OrderInfo,
            'goods-info': GoodsInfo
        },
        data() {
            return {
                activeNamess: ["13"],
                sumPrice: 0,
                userRole: localStorage.getItem("userRole"),
                popShow: false,
                columns: [],
                activeNames: ["3"],
                activeName: ["2"],
                checked: true,
                tabActive: 1,
                isOpen1: false,
                openText1: "展开",
                openIcon1: "arrow-down",
                orderInfo: {},
                orders: {},
                milkdeductamount: {},
                curdata: JSON.parse(localStorage.getItem("curdata")),
                curdataAlready: JSON.parse(localStorage.getItem("curdataAlready")),
                actionStatus: localStorage.getItem('actionStatus'),
                workflowLog: [],
                orderErpinfos: [],
                data: {},
                order: {},
                workFlow: {},
                workFlowTypeName: '',
                workFlowTypeId: '',
                stockremark: '',
                radio: '',
                shouldPayPrice: '',
                orderPayLogs: {},
                tempQuota: '',
                entIndex: 0,
                orgIndex: 0,
                changeShow: false,
                fefund: {
                    isErp: true,

                    id: '',
                    value: '',
                    popShow: false,
                    columns: [],

                    idd: '',
                    valued: '',
                    popShowd: false,
                    columnsd: []
                },
                erp: {
                    isErp: true,
                    isPromotionGiveOrder: true,
                    jamubiao: false,
                    entityValue: '',
                    entityColumns: [],
                    entityPopShow: false,
                    entityId: ''
                },
                org: {
                    id: '',
                    value: '',
                    popShow: false,
                    columns: []
                },
                dec: {
                    id: '',
                    value: '',
                    code: '',
                    popShow: false,
                    columns: []
                },
                sec: {
                    id: '',
                    value: '',
                    code: '',
                    popShow: false,
                    columns: []
                },
                odt: {
                    id: '',
                    value: '',
                    popShow: false,
                    columns: []
                },
                jmb: {
                    id: '',
                    value: '',
                    popShow: true,
                    columns: []
                },
                ptm: {
                    id: '',
                    value: '',
                    popShow: false,
                    columns: []
                },
                ywy: {
                    id: '',
                    value: '',
                    popShow: false,
                    columns: []
                },
                chetype: '1',
                cheCode: '',
                phone: '',
                birthday: "",
                driverName: '',
                driverIdnumber: '',
                speedy_input: "",
                popDateShow: false,
                fhInfo: '',
                currentDate: new Date(),
                sourceTypeCode: 'INTERNAL',
                isNotNull: '',
                erpJson: {},
                ordergoods: [],
                orderLogs: [],
                milkDeductLog: [],
                shenhefangshi: '0',
                accessoryId: '',
                imgUrl: '',
                imgeshow: false,
                workflowFileList: [],
                picimgUrl: '',
                picimgeshow: false,
                changeSynErps: true,
                calculationPrice: 0,
                urlList: [],
                isUplodReceivedCount: false,
                shipmentInfoLog: [],
                failCode: '',
                outGoodCode: [],
                goodscheckStork: '',
                goodsData:[],
                 queryType:0,//订单状态 待审批还是已审批
                 workflowType:0
              
            };
        },
        created (){
           this.onDateConfirm(this.currentDate);
        },
        mounted() {
             this.initData()
            localStorage.setItem('jmbid', '')
            localStorage.setItem('isjmbid', '')
            localStorage.setItem("goodjg", '');
            localStorage.setItem("cheguanbao", JSON.stringify([]));
            localStorage.setItem("receivedCount", JSON.stringify([]));
            localStorage.setItem("isReceivedCount", 0);
            localStorage.setItem("goodsCartArr", JSON.stringify(""));

            // } else if (this.actionStatus == "true") {
            //     var orderid = this.curdataAlready.id;
            //     let that = this;
            //     this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo, {'workFlowId': orderid, 'flag': false},
            //         successRes => {
            //             if (successRes.success) {
            //                 that.orders = successRes.data.orders
            //                 that.order = successRes.data.orders
            //                 that.outGoodCode = successRes.data.orderGoods
            //                 that.milkdeductamount = successRes.data.appUser;//奶款信息
            //                 try {
            //                     if(successRes.data.isSuBmAudit){
            //                         that.ywy.value = that.milkdeductamount.businessManUserCode.split(',')[0]
            //                         that.ptm.value = '立即付款'
            //                         that.ptm.id = '1001'
            //                     }
            //                 } catch (e) {
            //                 }
            //             }
            //         })
            // }
            // //
            
            this.getDictionaryByCode()//延迟原因
        },
        methods: {
            initData() {
               
                var orderid = null
                if (this.actionStatus == "false") {//待审批
                    orderid = this.curdata.id;
                     this.queryType=1;
                } else {
                    orderid = this.curdataAlready.workFlow_id;
                     this.queryType=2;
                }
                let that = this;
                this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo, {'workFlowId': orderid, 'flag': true,'queryType':this.queryType},
                    successRes => {
                        that.tabActive = 2
                        that.jmb.popShow = false
                        if (successRes.success) {
                            localStorage.setItem("approvalData", JSON.stringify(successRes.data))
                            that.orders = successRes.data.orders
                            that.order = successRes.data.orders
                            that.outGoodCode = successRes.data.orderGoods
                            that.milkdeductamount = successRes.data.appUser;//奶款信息
                            try {
                                /*if (successRes.data.isSuBmAudit) {
                                    that.ywy.value = that.milkdeductamount.businessManUserCode.split(',')[0]
                                    that.ptm.value = '立即付款'
                                    that.ptm.id = '1001'
                                }*/
                                that.ywy.value = that.milkdeductamount.businessManUserCode.split(',')[0]
                                that.ptm.value = '立即付款'
                                that.ptm.id = '1001'
                            } catch (e) {
                            }
                            that.shipmentInfoLog = successRes.data.shipmentInfoLog
                            that.milkDeductLog = successRes.data.milkDeductLog
                            that.ordergoods = successRes.data.orderGoods
                            that.milkdeductamount = successRes.data.appUser;//奶款信息
                            that.workflowLog = successRes.data.workflowLog
                            that.orderErpinfos = successRes.data.orders.orderErpinfos
                            that.data = successRes.data
                            that.order = successRes.data.orders
                            if (that.calculationPrice == 0 || that.calculationPrice == '' || that.calculationPrice == null) {
                                that.calculationPrice = successRes.data.calculationPrice
                                //初始化本次扣减奶款
                                that.sumPrice = 0
                                for (let k = 0; k < that.ordergoods.length; k++) {
                                    //运费(每个商品)
                                    let good = that.ordergoods[k]
                                    let freight = good.freight == null ? 0 : good.freight
                                    //折扣
                                    /*   let discount = good.discount == null ? 1 : good.discount
                                       let pay_discount = good.pay_discount == null ? 1 : good.pay_discount*/
                                    if (good.parent_cart_id == null || good.parent_cart_id == '') {
                                        that.sumPrice = that.sumPrice + good.price * good.received_count + good.received_count * (freight / good.count)
                                    } else {
                                        that.sumPrice = that.sumPrice + 0
                                    }
                                }
                                that.sumPrice = that.sumPrice - that.order.usePointAmount
                            }
                            if (isNaN(that.calculationPrice) || isNaN(that.sumPrice)) {
                                that.calculationPrice = that.data.calculationPrice
                                //初始化本次扣减奶款
                                that.sumPrice = 0
                                for (let k = 0; k < that.ordergoods.length; k++) {
                                    //运费(每个商品)
                                    let good = that.ordergoods[k]
                                    let freight = good.freight == null ? 0 : good.freight
                                    //折扣
                                    /*let discount = good.discount == null ? 1 : good.discount
                                    let pay_discount = good.pay_discount == null ? 1 : good.pay_discount*/
                                    if (good.parent_cart_id == null || good.parent_cart_id == '') {
                                        that.sumPrice = that.sumPrice + good.price * good.received_count + good.received_count * (freight / good.count)
                                    } else {
                                        that.sumPrice = that.sumPrice + 0
                                    }
                                }
                                that.sumPrice = that.sumPrice - that.order.usePointAmount
                            }
                            that.workflowFileList = successRes.data.workflowFileList
                            var workflowFileList = successRes.data.workflowFileList
                            for (let i = 0; i < workflowFileList.length; i++) {
                                let json = {}
                                json['id'] = workflowFileList[i].id
                                json['fileUrl'] = workflowFileList[i].fileUrl
                                json['file_type'] = workflowFileList[i].file_type
                                that.urlList[i] = json
                            }
                            if (localStorage.getItem("approvalListSycn") == '0') {
                                that.erp.isErp = successRes.data.isSynErp
                                localStorage.setItem("approvalListSycn", 1);
                            }

                            that.chetype = that.chetype == '' ? that.order.trainType + '' : that.chetype
                            that.phone = that.phone == '' ? that.order.mobileDriver : that.phone
                            that.cheCode = that.cheCode == '' ? that.order.plateNo : that.cheCode
                            that.birthday = that.birthday == '' ? that.order.departureTime : that.birthday
                            that.driverName = that.driverName == '' ? that.order.driverName : that.driverName
                            that.driverIdnumber = that.driverIdnumber == '' ? that.order.driverIdnumber : that.driverIdnumber

                            that.orderLogs = successRes.data.orderLogs
                            that.workFlow = successRes.data.workFlow
                            that.workFlowType=successRes.data.workFlow.workflowType
                            that.tempQuota = that.data.tempQuota
                            that.shouldPayPrice = that.data.calculationPrice
                            that.orderPayLogs = successRes.data.orderPayLogs[0]
                            if (that.orderPayLogs == undefined) {
                                that.orderPayLogs = {}
                            }
                            for (let h = 0; h < that.milkdeductamount.milkShopList.length; h++) {
                                if (that.milkdeductamount.milkShopList[h].id == that.milkdeductamount.org_milk_shop_id) {
                                    that.radio = successRes.data.appUser.milkShopList[h].orgCode
                                }
                            }
                        }
                          
                    })
            },
            deliveryGoodPlanSow(type) {
                let that = this
                localStorage.setItem("ordergoodsPlan", JSON.stringify(that.ordergoods));
                that.$router.push({
                    path: '/staff/order/delivery/plan/show',
                    query: {
                        workflowId: that.data.workFlow.id,
                        type: type,
                        transport: that.data.orders.transport
                    }
                })
            },
            deliveryGoodPlan(type) {
                let that = this
                localStorage.setItem("ordergoodsPlan", JSON.stringify(that.ordergoods));
                that.$router.push({
                    path: '/staff/order/delivery/plan',
                    query: {
                        workflowId: that.data.workFlow.id,
                        type: type,
                        transport: that.data.orders.transport
                    }
                })
            },
            shippingInfoEdit() {
                let that = this
                let goodsCartArr = JSON.parse(localStorage.getItem("goodsCartArr"));
                if (goodsCartArr == null || goodsCartArr == '') {
                    let ordergood = that.data.orderGoods
                    goodsCartArr = []
                    for (var i = 0; i < ordergood.length; i++) {
                        let gcb = {}
                        gcb['goodsCartId'] = ordergood[i].cart_id
                        gcb['shipPriceValue'] = 0
                        goodsCartArr[i] = gcb
                    }
                }
                that.erpJson = {
                    "workflowId": that.data.workFlow.id,
                    "departureTime": that.birthday,
                    "plateNo": that.cheCode,
                    "mobileDriver": that.phone,
                    "trainType": that.chetype,
                    "driverName": that.driverName,
                    "driverIdnumber": that.driverIdnumber,
                    "goodsCartArr": JSON.stringify(goodsCartArr)
                }
                localStorage.setItem("goodsCartArr", JSON.stringify(""));
                that.$api.post(that.jumuc.stock.saveDriver,
                    that.erpJson,
                    successRes => {
                        Dialog.alert({
                            title: '',
                            message: successRes.msg
                        }).then(() => {
                            if (successRes.success) {
                                that.$router.push({
                                    path: '/staff/approval'
                                })
                            }
                        });
                    })
            },
            changeSynErp(checked) {
                let that=this
                this.changeSynErps = checked
                if(!checked){

                    that.calculationPrice = that.data.calculationPrice
                    //初始化本次扣减奶款
                    that.sumPrice = 0
                    for (let k = 0; k < that.ordergoods.length; k++) {
                        //运费(每个商品)
                        let good = that.ordergoods[k]
                        let freight = good.freight == null ? 0 : good.freight
                        //折扣
                        /*let discount = good.discount == null ? 1 : good.discount
                        let pay_discount = good.pay_discount == null ? 1 : good.pay_discount*/
                        if (good.parent_cart_id == null || good.parent_cart_id == '') {
                            that.sumPrice = that.sumPrice + good.price * good.received_count + good.received_count * (freight / good.count)
                        } else {
                            that.sumPrice = that.sumPrice + 0
                        }
                    }
                    that.sumPrice = that.sumPrice - that.order.usePointAmount

                }
                that.erp.jamubiao = checked
                if (that.jmb.value != '') {
                    localStorage.setItem('isjmbid', checked)
                }
            },
            handlesumPrice(data) {
                let that = this
                that.sumPrice = data - that.order.usePointAmount
                //that.data.isBmOrder&&that.userRole.indexOf('BM')!=-1&&that.order.transport!='管车宝' 管车宝要重新计算(加上that.order.transport!='管车宝' 不会重新计算)
                if (that.data.isBmOrder && that.userRole.indexOf('BM') != -1) {
                    // data + that.order.shipPrice - that.order.usePointAmount that.order.shipPrice运费计算两次
                    that.calculationPrice = data - that.order.usePointAmount
                }
                if (isNaN(that.calculationPrice)) {
                    that.calculationPrice = that.data.calculationPrice
                }
            },
            handleoutGoodCode(data) {
                this.goodsData=data;
                let that = this
                that.goodscheckStork = ''
                for (let i = 0; i < that.outGoodCode.length; i++) {
                    that.goodscheckStork = that.goodscheckStork + data[i] + ',' + that.outGoodCode[i].shipment_count + ',' + that.outGoodCode[i].unit_zhxs + ';'
                }
            },
            getOutGoodsCode (){
                var that=this;
                that.goodscheckStork = ''
                for (let i = 0; i < that.outGoodCode.length; i++) {
                    that.goodscheckStork = that.goodscheckStork + this.goodsData[i] + ',' + that.outGoodCode[i].shipment_count + ',' + that.outGoodCode[i].unit_zhxs + ';'
                }
            },
            picimg(picimgUrl) {
                let that = this
                that.picimgUrl = picimgUrl
                that.picimgeshow = true
            },
            seeImge() {
                let that = this
                if (that.imgUrl == '') {
                    that.$toast('请先上传过磅单')
                } else {
                    that.imgeshow = true
                }
            },
            deImge(id) {
                let that = this
                that.$api.get(that.data.deleteImgUrl, {"picId": id}, successRes => {
                    if (successRes.result) {
                        that.urlList = []
                        let workflowFileList = successRes.data
                        for (let i = 0; i < workflowFileList.length; i++) {
                            let json = {}
                            json['id'] = workflowFileList[i].picId
                            json['fileUrl'] = workflowFileList[i].url
                            json['file_type'] = workflowFileList[i].file_type
                            that.urlList[i] = json
                        }
                        that.$toast('删除成功')
                    } else {
                        that.$toast('删除失败')
                    }
                })
            },
            onRead(file, detail) {
                let that = this;
                let fileFormData = new FormData();
                fileFormData.append('file', file.file)
                let fileType = 1
                if (that.data.isTmDealOne) {
                    fileType = 0;
                } else if (that.data.isTmDealTwo || that.data.isBmDealTwo) {
                    fileType = 1;
                }

                let delivery = 1
                if (that.order.isPartOut == 1) {
                    delivery = 0
                }
                fileFormData.append('fileType', fileType)
                fileFormData.append('workflowId', that.data.workFlow.id)
                fileFormData.append('delivery', delivery)
                fileFormData.append('userId', localStorage.getItem("userId"))
                that.$api.post(that.data.uploadUrl, fileFormData, successRes => {
                    if (successRes.result) {
                        that.urlList = []
                        let workflowFileList = successRes.data
                        for (let i = 0; i < workflowFileList.length; i++) {
                            let json = {}
                            json['id'] = workflowFileList[i].picId
                            json['fileUrl'] = workflowFileList[i].url
                            json['file_type'] = workflowFileList[i].file_type
                            that.urlList[i] = json
                        }
                        that.$toast('上传成功!');
                    } else {
                        that.$toast('上传失败!');
                    }
                })
            },
            viewDelivery() {
                let that = this
                that.$router.push({
                    path: '/staff/delivery/refunddetail',
                    query: {
                        orderId: that.order.id,
                        seeDelivery: 1
                    }
                });
            },
            depositGood() {
                let that = this
                that.$router.push({
                    path: '/user/order/depositGood',
                    query: {
                        id: that.workFlow.id
                    }
                })
            },
            showErpInfo(obj) {
                let that = this
                that.$router.push({
                    path: '/erporder',
                    query: {
                        id: obj.id,
                        type: obj.orderType
                    }
                })
            },
            getsumPrice() {
                let that = this
                that.sumPrice = 0
                if (that.erp.isErp && that.erp.jamubiao) {//同步erp
                    that.sumPrice = localStorage.getItem("sumPrice")
                    if (that.sumPrice == null || that.sumPrice == 0 || that.sumPrice == '0') {
                        let sumPrice = 0
                        for (var n = 0; n < that.ordergoods.length; n++) {
                            sumPrice = sumPrice + that.ordergoods[n].minSum
                        }
                        that.sumPrice = sumPrice
                    }
                } else {
                    for (var k = 0; k < that.ordergoods.length; k++) {
                        let good = that.ordergoods[k]
                        that.sumPrice = that.sumPrice + good.price * good.shipment_count
                    }
                }
                that.sumPrice = that.sumPrice - that.order.usePointAmount
            },
            deliverGoodsNum() {
                let that = this
                that.$router.push({
                    path: '/user/order/deliver-goods-num',
                    query: {
                        id: that.workFlow.id,
                        type: 'fh'
                    }
                })
            },
            showDate() {
                this.popDateShow = true;
            },
            onDateConfirm(value) {
                const d = new Date(value)
                const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
                const resTime = this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds())
                this.birthday = resDate + ' ' + resTime;
                this.popDateShow = false;
            }, p(s) {
                return s < 10 ? '0' + s : s
            },
            getOuByCus() {
                let that = this;
                that.$api.post(that.jumuc.userCenter.getOuByCus, {"id": that.milkdeductamount.id},
                    successRes => {
                        that.erp.entityColumns = JSON.parse(successRes.data).data
                    })
            },
            getDictionaryByCode() {
                let that = this;
                that.$api.post(that.jumuc.userCenter.getDictionaryByCode, {"entrycode": 401},
                    successRes => {
                        that.columns = successRes.data
                    })
            },
            onPickerCancel() {
                this.popShow = false;
            },
            onPickerConfirm(values) {
                let that = this
                this.workFlowTypeName = values.dictdata_value;
                this.workFlowTypeId = values.id;
                this.popShow = false;
                that.$api.post(that.jumuc.stock.changeDealyDeal,
                    {"workflowId": that.data.workFlow.id, "remarkId": values.id},
                    successRes => {
                        that.$toast(successRes.msg);
                        if (successRes.success) {
                            that.data.checkDelay = true
                            that.initData()
                        }

                    })
            },
            onPickerChange(picker, values) {
                picker.setColumnValues(1, values.dictdata_value)
            },
            showPop() {
                let that = this
                that.popShow = true;
            },
            back() {
                //history.back();
                  this.$router.replace('/staff/approval')
            },
            /* change(index, title) {
                 let that = this;
                 if (index == 2) {
                     var orderid = localStorage.getItem("workflow_id");
                     this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo, {'workFlowId': orderid, 'flag': true},
                         successRes => {
                             if (successRes.success) {
                                 that.tabActive = 2
                                 that.shipmentInfoLog = successRes.data.shipmentInfoLog
                                 that.milkDeductLog = successRes.data.milkDeductLog
                                 that.ordergoods = successRes.data.orderGoods
                                 that.milkdeductamount = successRes.data.appUser;//奶款信息
                                 that.workflowLog = successRes.data.workflowLog
                                 that.orderErpinfos = successRes.data.orders.orderErpinfos
                                 that.data = successRes.data
                                 that.order = successRes.data.orders
                                 if (that.calculationPrice == 0 || that.calculationPrice == '' || that.calculationPrice == null) {
                                     that.calculationPrice = successRes.data.calculationPrice
                                     //初始化本次扣减奶款
                                     that.sumPrice = 0
                                     for (let k = 0; k < that.ordergoods.length; k++) {
                                         //运费(每个商品)
                                         let good = that.ordergoods[k]
                                         let freight = good.freight == null ? 0 : good.freight
                                         //折扣
                                         /!*   let discount = good.discount == null ? 1 : good.discount
                                            let pay_discount = good.pay_discount == null ? 1 : good.pay_discount*!/
                                         if (good.parent_cart_id == null || good.parent_cart_id == '') {
                                             that.sumPrice = that.sumPrice + good.price * good.received_count + good.received_count * (freight / good.count)
                                         } else {
                                             that.sumPrice = that.sumPrice + 0
                                         }
                                     }
                                     that.sumPrice = that.sumPrice - that.order.usePointAmount
                                 }
                                 if (isNaN(that.calculationPrice) || isNaN(that.sumPrice)) {
                                     that.calculationPrice = that.data.calculationPrice
                                     //初始化本次扣减奶款
                                     that.sumPrice = 0
                                     for (let k = 0; k < that.ordergoods.length; k++) {
                                         //运费(每个商品)
                                         let good = that.ordergoods[k]
                                         let freight = good.freight == null ? 0 : good.freight
                                         //折扣
                                         /!*let discount = good.discount == null ? 1 : good.discount
                                         let pay_discount = good.pay_discount == null ? 1 : good.pay_discount*!/
                                         if (good.parent_cart_id == null || good.parent_cart_id == '') {
                                             that.sumPrice = that.sumPrice + good.price * good.received_count + good.received_count * (freight / good.count)
                                         } else {
                                             that.sumPrice = that.sumPrice + 0
                                         }
                                     }
                                     that.sumPrice = that.sumPrice - that.order.usePointAmount
                                 }
                                 that.workflowFileList = successRes.data.workflowFileList
                                 var workflowFileList = successRes.data.workflowFileList
                                 for (let i = 0; i < workflowFileList.length; i++) {
                                     let json = {}
                                     json['id'] = workflowFileList[i].id
                                     json['fileUrl'] = workflowFileList[i].fileUrl
                                     json['file_type'] = workflowFileList[i].file_type
                                     that.urlList[i] = json
                                 }
                                 if (localStorage.getItem("approvalListSycn") == '0') {
                                     that.erp.isErp = successRes.data.isSynErp
                                     localStorage.setItem("approvalListSycn", 1);
                                 }

                                 that.chetype = that.chetype == '' ? that.order.trainType + '' : that.chetype
                                 that.phone = that.phone == '' ? that.order.mobileDriver : that.phone
                                 that.cheCode = that.cheCode == '' ? that.order.plateNo : that.cheCode
                                 that.birthday = that.birthday == '' ? that.order.departureTime : that.birthday
                                 that.driverName = that.driverName == '' ? that.order.driverName : that.driverName
                                 that.driverIdnumber = that.driverIdnumber == '' ? that.order.driverIdnumber : that.driverIdnumber

                                 that.orderLogs = successRes.data.orderLogs
                                 that.workFlow = successRes.data.workFlow
                                 that.tempQuota = that.data.tempQuota
                                 that.shouldPayPrice = that.data.calculationPrice
                                 that.orderPayLogs = successRes.data.orderPayLogs[0]
                                 for(let h=0;h<that.milkdeductamount.milkShopList.length;h++){
                                     if(that.milkdeductamount.milkShopList[h].id==that.milkdeductamount.org_milk_shop_id){
                                         that.radio = successRes.data.appUser.milkShopList[h].orgCode
                                     }
                                 }

                             }
                         })
                 }

             },*/
            showOpen1(i) {
                this.isOpen1 = !this.isOpen1;
                this.openText1 = this.isOpen1 ? '收起' : '展开';
                this.openIcon1 = this.isOpen1 ? 'arrow-up' : 'arrow-down';
            }, ywybh() {
                let that = this
                 if (that.stockremark == '') {
                    that.$toast('请输入驳回原因')
                    return false
                }
                let json = {
                    "workflowId": that.data.workFlow.id,
                    "currentSquence": that.data.workFlow.currentSquence,
                    "status": 0,
                    "remark": that.stockremark
                }

                that.$api.post(that.jumuc.stock.savedeal,
                    json,
                    successRes => {
                        Dialog.alert({
                            title: '',
                            message: successRes.msg
                        }).then(() => {
                            if (successRes.success) {
                                that.$router.push({
                                    path: '/staff/approval'
                                })
                            }
                        });
                    })
            }, getIsUplodReceivedCount() {
                let that = this
                that.isUplodReceivedCount = false
                for (var k = 0; k < that.urlList.length; k++) {
                    if (that.urlList[k].file_type == 1) {
                        that.isUplodReceivedCount = true
                    }
                }
            }, savedeal(id) {
                let that = this
                this.getOutGoodsCode();
                /*that.getsumPrice()*/
                let isReceivedCount = localStorage.getItem("isReceivedCount")
                let json = {}
                if (id == 0 && that.stockremark == '') {
                    that.$toast('请输入驳回原因')
                    return false
                }
                let isExe = false
                if (id != 0 && that.data.isBmDealOne || that.data.isTmDealOne) { //贸易流程业务员第一次审批
                    isExe = true
                    let shipPrices = JSON.parse(localStorage.getItem("cheguanbao"))
                    if (that.data.isBmDealOne && that.data.orders.transport == '管车宝') {
                        if (shipPrices == null || shipPrices == 'null') {
                            that.$toast('请输入管车保运费')
                            return false;
                        }
                        for (var i = 0; i < shipPrices.length; i++) {
                            if (shipPrices[i].shipPrice.trim() == '') {
                                that.$toast('请输入管车保运费')
                                return false;
                            }
                        }
                    }

                    /*if (that.data.isBmDealOne && (that.data.orders.transport == '管车宝' || that.data.orders.transport == '自提')) {
                        //配送方式为管车宝才校验发运信息
                        if (that.isNotNullBus()) {
                            return false;
                        }
                    }*/
                    if (id != 0 && that.data.isTmDealOne && that.data.orders.transport == '物流配送') {
                        //配送方式为管车宝才校验发运信息
                        if (that.isNotNullBus()) {
                            return false;
                        }
                    }
                    that.erpJson = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        "remark": that.stockremark,
                        "departureTime": that.birthday,
                        "plateNo": that.cheCode,
                        "driverName": that.driverName,
                        "driverIdnumber": that.driverIdnumber,
                        "approvalType": that.shenhefangshi,
                        "mobileDriver": that.phone,
                        "trainType": that.chetype,
                        "shipPrices": JSON.stringify(shipPrices),
                    }

                    //wangting 修改 业务员审核添加预扣字段
                    that.erpJson['beforeDeductAmount'] = that.calculationPrice
//                    if((that.order.transport=='自提'||that.order.transport=='管车宝') && that.workFlow.workflowType==10){
//                        that.erpJson['beforeDeductAmount']=that.calculationPrice
//                    }
                    that.$api.post(that.jumuc.stock.savedeal,
                        that.erpJson,
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }

                isClose:if (that.data.isBmDealTwo) { //贸易流程业务员第二次审批 JSON.parse(localStorage.getItem("receivedCount")),
                    if (isExe) {
                        break isClose;
                    }
                    isExe = true
                    that.getIsUplodReceivedCount()
                    if (id != 0 && isReceivedCount == 1 && !that.isUplodReceivedCount) {
                        that.$toast('发货数量和到货数量不一致请上传过磅单')
                        return false
                    }
                    let receivedCounts = JSON.parse(localStorage.getItem("receivedCount"))
                    if (receivedCounts == null || receivedCounts == 'null' || receivedCounts.length < 1) {
                        var len = that.ordergoods.length;
                        for (let i = 0; i < len; i++) {
                            let jsons = {}
                            jsons['name'] = 'receivedCount_' + that.ordergoods[i].cart_id
                            jsons['value'] = that.ordergoods[i].receivedCount
                            receivedCounts[i] = jsons
                        }
                    }
                    that.erpJson = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        "remark": that.stockremark,
                        "receivedCounts": JSON.stringify(receivedCounts)
                    }
                    that.$api.post(that.jumuc.stock.savedeal,
                        that.erpJson,
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }

                isClose11:if (that.data.isTmDealTwo) { //贸易流程贸易专员第二次审批
                    if (isExe) {
                        break isClose11;
                    }
                    isExe = true
                    let receivedCounts = JSON.parse(localStorage.getItem("receivedCount"))
                    if (receivedCounts == null || receivedCounts == 'null' || receivedCounts.length < 1) {
                        var len = that.ordergoods.length;
                        for (let i = 0; i < len; i++) {
                            let jsons = {}
                            jsons['name'] = 'receivedCount_' + that.ordergoods[i].cart_id
                            jsons['value'] = that.ordergoods[i].receivedCount
                            receivedCounts[i] = jsons
                        }
                    }
                    that.erpJson = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        "remark": that.stockremark,
                        "receivedCounts": JSON.stringify(receivedCounts),
                        "syncErp": that.erp.isErp == true ? 1 : 0
                    }
                    if (id != 0 &&that.erp.isErp) {//同步erp
                        that.getIsNotNull()
                        if (that.isNotNull != '') {
                            that.$toast(that.isNotNull)
                        } else {
                            that.erpJson['workflowId'] = that.data.workFlow.id
                            that.erpJson['currentSquence'] = that.data.workFlow.currentSquence
                            that.erpJson['status'] = id
                            that.erpJson['remark'] = that.stockremark
                            that.erpJson['syncErp'] = that.erp.isErp == true ? 1 : 0

                            if (that.erp.jamubiao) {//节目表价格
                                that.erpJson['priceListGoodsPrice'] = localStorage.getItem("goodjg")
                            }
                            that.$api.post(that.jumuc.stock.savedeal,
                                that.erpJson,
                                successRes => {
                                    Dialog.alert({
                                        title: '',
                                        message: successRes.msg
                                    }).then(() => {
                                        if (successRes.success) {
                                            that.$router.push({
                                                path: '/staff/approval'
                                            })
                                        }
                                    });
                                })
                        }
                    } else {
                        that.$api.post(that.jumuc.stock.savedeal,
                            that.erpJson,
                            successRes => {
                                Dialog.alert({
                                    title: '',
                                    message: successRes.msg
                                }).then(() => {
                                    if (successRes.success) {
                                        that.$router.push({
                                            path: '/staff/approval'
                                        })
                                    }
                                });
                            })
                    }
                }

                isClose12:if ((that.data.isBmOrder || that.userRole.indexOf('RM') > -1) && !that.data.isBmDealTwo && that.workFlow.workflowType != 2) {//业务员奶款支付订单   库管审核
                    if (isExe) {
                        break isClose12;
                    }
                    isExe = true;
                  
                            that.erpJson = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        "orgMilkShop": that.radio,
                        'beforeDeductAmount': that.calculationPrice,
                        "remark": that.stockremark
                    }
                    that.erpJson['finalDeductAmount'] = that.sumPrice
                    if (id != 0 &&that.data.isSuBmAudit) {
                        if (that.erp.isErp) {//同步erp
                            that.getIsNotNull()
                            if (that.isNotNull != '' && id == 1) {
                                that.$toast(that.isNotNull)
                                return false
                            }
                        }
                        //如果变更为邮寄需要传发运信息
                        if (that.data.orders.transport == "" && id == 1) {
                            if (that.isNotNullBus()) {
                                return false;
                            }
                            that.erpJson['shipInfo'] = that.fhInfo
                            that.erpJson['departureTime'] = that.birthday
                            that.erpJson['plateNo'] = that.cheCode
                            that.erpJson['mobileDriver'] = that.phone
                            that.erpJson['trainType'] = that.chetype
                            that.erpJson['driverName'] = that.driverName
                            that.erpJson['driverIdnumber'] = that.driverIdnumber
                        }
                        that.getJxC()
                    }
                    that.$api.post(that.jumuc.stock.savedeal,
                        that.erpJson,
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                    
                  
                }
                //业务员审批非奶款订单
                isClose13:if (!that.data.isBmOrder && that.userRole.indexOf('BM') > -1 && that.workFlow.workflowType != 5 && !that.data.isWmFstCPAudit && !that.data.isWmSedCPAudit) {
                    if (isExe) {
                        break isClose13;
                    }
                    isExe = true
                    that.erpJson = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        "orgMilkShop": that.radio,
                        "remark": that.stockremark,
                    }
                    if (that.data.isSuBmAudit) {
                        that.erpJson['goodscheckStork'] = that.goodscheckStork
                    }
                    that.erpJson['finalDeductAmount'] = that.sumPrice
                    if (id != 0 &&that.data.isSuBmAudit) {
                        if (that.erp.isErp) {//同步erp syncErp": that.erp.isErp == true ? 1 : 0"]
                           that.erpJson["syncErp"]=that.erp.isErp == true ? 1 : 0;
                            that.getIsNotNull()
                            if (that.isNotNull != '' && id == 1) {
                                that.$toast(that.isNotNull)
                                return false
                            }
                        }
                        //如果变更为邮寄需要传发运信息
                        if (that.data.orders.transport == "") {
                            if (that.isNotNullBus()) {
                                return false;
                            }
                            that.erpJson['shipInfo'] = that.fhInfo
                            that.erpJson['departureTime'] = that.birthday
                            that.erpJson['plateNo'] = that.cheCode
                            that.erpJson['mobileDriver'] = that.phone
                            that.erpJson['trainType'] = that.chetype
                            that.erpJson['driverName'] = that.driverName
                            that.erpJson['driverIdnumber'] = that.driverIdnumber
                        }
                        that.getJxC()
                    }

                    that.$api.post(that.jumuc.stock.savedeal,
                        that.erpJson,
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }
                //财务
                isClose14:if (that.workFlow.roleDeal == 'FM' && (that.orderPayLogs.pay_class == 3 || that.orderPayLogs.pay_class == 5) && that.workFlow.workflowType != 5) {
                    if (isExe) {
                        break isClose14;
                    }
                    isExe = true
                    json = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        'tempQuota': that.tempQuota,
                        "remark": that.stockremark
                    }
                    if (that.orderPayLogs.pay_class == 5) {
                        json = {
                            "workflowId": that.data.workFlow.id,
                            "currentSquence": that.data.workFlow.currentSquence,
                            "status": id,
                            "remark": that.stockremark
                        }
                    }
                    that.$api.post(that.jumuc.stock.savedeal,
                        json,
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }
                //调度员第二次次审批
                isClose15:if (that.data.isWmSedCPAudit) {
                    if (isExe) {
                        break isClose15;
                    }
                    isExe = true
                    json = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        "remark": that.stockremark,
                        "finalDeductAmount": that.sumPrice
                    }
                    that.$api.post(that.jumuc.stock.savedeal,
                        json,
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }

                //超市商品业务员审核 || 调度员第一次审批 ||
                isClose16:if (that.data.isSuBmAudit || that.data.isWmFstCPAudit) {
                    if (isExe) {
                        break isClose16;
                    }
                    isExe = true
                      if(that.radio==''){
                        this.$toast('请选择奶牛发货超市！')
                    }else{
                    that.erpJson = {
                        "workflowId": that.data.workFlow.id,
                        "currentSquence": that.data.workFlow.currentSquence,
                        "status": id,
                        "remark": that.stockremark,
                        "syncErp": that.erp.isErp == true ? 1 : 0,
                        "orgMilkShop": that.radio,
                        "finalDeductAmount": that.sumPrice
                    }
                    if (that.data.isSuBmAudit) {
                        that.erpJson['goodscheckStork'] = that.goodscheckStork
                    }

                    //如果变更为邮寄需要传发运信息
                    if (that.data.orders.transport == "") {
                        if (that.isNotNullBus()) {
                            return false;
                        }

                        that.erpJson = {
                            "workflowId": that.data.workFlow.id,
                            "currentSquence": that.data.workFlow.currentSquence,
                            "status": id,
                            "remark": that.stockremark,
                            "syncErp": that.erp.isErp == true ? 1 : 0,
                            "orgMilkShop": that.radio,
                            "finalDeductAmount": that.sumPrice,
                            "shipInfo": that.fhInfo,
                            "departureTime": that.birthday,
                            "plateNo": that.cheCode,
                            "mobileDriver": that.phone,
                            "trainType": that.chetype,
                            "driverName": that.driverName,
                            "driverIdnumber": that.driverIdnumber,
                        }
                    }
                    if (id != 0 &&that.data.isWmFstCPAudit) { //调度员第一次审批
                        if (that.isNotNullBus()) {
                            return false;
                        }

                        that.erpJson = {
                            "workflowId": that.data.workFlow.id,
                            "currentSquence": that.data.workFlow.currentSquence,
                            "status": id,
                            "remark": that.stockremark,
                            "syncErp": that.erp.isErp == true ? 1 : 0,
                            "shipInfo": that.fhInfo,
                            "departureTime": that.birthday,
                            "driverName": that.driverName,
                            "driverIdnumber": that.driverIdnumber,
                            "plateNo": that.cheCode,
                            "mobileDriver": that.phone,
                            "trainType": that.chetype
                        }
                    }
                    that.getJxC()
                    if (id != 0 &&that.erp.isErp) {//同步erp
                        that.getIsNotNull()
                        if (that.isNotNull != '' && id == 1) {
                            that.$toast(that.isNotNull)
                        } else {
                            that.erpJson['workflowId'] = that.data.workFlow.id
                            that.erpJson['currentSquence'] = that.data.workFlow.currentSquence
                            that.erpJson['status'] = id
                            that.erpJson['remark'] = that.stockremark
                            that.erpJson['syncErp'] = that.erp.isErp == true ? 1 : 0
                            that.erpJson['synGiftErp'] = that.erp.isPromotionGiveOrder == true ? 1 : 0
                            that.erpJson['orgMilkShop'] = that.radio
                            if (that.data.isWmFstCPAudit || that.data.orders.transport == "") {

                                if (that.isNotNullBus()) {
                                    return false;
                                }
                                that.erpJson['shipInfo'] = that.fhInfo
                                that.erpJson['departureTime'] = that.birthday
                                that.erpJson['plateNo'] = that.cheCode
                                that.erpJson['mobileDriver'] = that.phone
                                that.erpJson['trainType'] = that.chetype
                                that.erpJson['driverName'] = that.driverName
                                that.erpJson['driverIdnumber'] = that.driverIdnumber
                            }

                            if (that.erp.jamubiao) {//节目表价格
                                that.erpJson['priceListGoodsPrice'] = localStorage.getItem("goodjg")
                            }
                            that.$api.post(that.jumuc.stock.savedeal,
                                that.erpJson,
                                successRes => {
                                    Dialog.alert({
                                        title: '',
                                        message: successRes.msg
                                    }).then(() => {
                                        if (successRes.success) {
                                            that.$router.push({
                                                path: '/staff/approval'
                                            })
                                        }
                                    });
                                })
                        }
                    } else {
                        that.$api.post(that.jumuc.stock.savedeal,
                            that.erpJson,
                            successRes => {
                                Dialog.alert({
                                    title: '',
                                    message: successRes.msg
                                }).then(() => {
                                    if (successRes.success) {
                                        that.$router.push({
                                            path: '/staff/approval'
                                        })
                                    }
                                });
                            })
                    }
                    }
                }
                //非入库审批 贸易第一次
                isClose3:if (that.workFlow.workflowType == 4 && that.data.isTmFstNotinAudit) {
                    if (isExe) {
                        break isClose3;
                    }
                    isExe = true
                    that.$api.post(that.jumuc.stock.savedeal,
                        {
                            "workflowId": that.data.workFlow.id,
                            "currentSquence": that.data.workFlow.currentSquence,
                            "status": id,
                            "remark": that.stockremark,
                            "shipInfo": that.fhInfo,
                            "departureTime": that.birthday,
                            "plateNo": that.cheCode,
                            "mobileDriver": that.phone,
                            "driverName": that.driverName,
                            "driverIdnumber": that.driverIdnumber,
                            "trainType": that.chetype
                        },
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        }
                    )
                }
                //非入库审批 贸易第二次
                isClose4:if (that.workFlow.workflowType == 4 && that.data.isTmSedNotinAudit) {
                    if (isExe) {
                        break isClose4;
                    }
                    isExe = true
                    if (id != 0 &&that.erp.isErp) {//同步erp
                        //todo 2019-08-08 若不同步erp 不需要校验erp 信息 参照isclose2
                        that.getIsNotNull()
                    }
                    if (that.isNotNull != '' && id == 1) {
                        that.$toast(that.isNotNull)
                        return false
                    }
                    /* if (that.isNotNullBus()) {
                         return false;
                     }*/
                    that.erpJson['workflowId'] = that.data.workFlow.id,
                        that.erpJson['currentSquence'] = that.data.workFlow.currentSquence,
                        that.erpJson['status'] = id
                    that.erpJson['remark'] = that.stockremark,
                        that.erpJson['shipInfo'] = that.fhInfo,
                        that.erpJson['departureTime'] = that.birthday,
                        that.erpJson['plateNo'] = that.cheCode,
                        that.erpJson['mobileDriver'] = that.phone,
                        that.erpJson['driverName'] = that.driverName,
                        that.erpJson['driverIdnumber'] = that.driverIdnumber,
                        that.erpJson['trainType'] = that.chetype,
                        that.erpJson['syncErp'] = that.erp.isErp == true ? 1 : 0
                    that.erpJson['finalDeductAmount'] = that.sumPrice

                    that.$api.post(that.jumuc.stock.savedeal,
                        that.erpJson,
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }

                //非入库审批 调度
                isClose5:if (that.workFlow.workflowType == 4 && that.data.isWmFstNotinAudit) {
                    if (isExe) {
                        break isClose5;
                    }
                    isExe = true
                    that.$api.post(that.jumuc.stock.savedeal,
                        {
                            "workflowId": that.data.workFlow.id,
                            "currentSquence": that.data.workFlow.currentSquence,
                            "status": id,
                            "remark": that.stockremark
                        },
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }

                //退货 无需同步的审批
                isClose6:if (that.workFlow.workflowType == 5 && that.userRole.indexOf('FM') == -1) {
                    if (isExe) {
                        break isClose6;
                    }
                    isExe = true
                    that.$api.post(that.jumuc.stock.savedeal,
                        {
                            "workflowId": that.data.workFlow.id,
                            "currentSquence": that.data.workFlow.currentSquence,
                            "status": id,
                            "remark": that.stockremark
                        },
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }

                //退货财务
                isClose7:if (that.workFlow.workflowType == 5 && that.userRole.indexOf('FM') > -1) {
                    if (isExe) {
                        break isClose7;
                    }
                    isExe = true
                    that.$api.post(that.jumuc.stock.savedeal,
                        {
                            "workflowId": that.data.workFlow.id,
                            "currentSquence": that.data.workFlow.currentSquence,
                            "status": id,
                            "remark": that.stockremark,
                            synErp: that.fefund.isErp,
                            businessType: that.fefund.id,
                            businessTypeName: that.fefund.value,
                            returnReasonCode: that.fefund.idd,
                            returnReasonDes: that.fefund.valued
                        },
                        successRes => {
                            Dialog.alert({
                                title: '',
                                message: successRes.msg
                            }).then(() => {
                                if (successRes.success) {
                                    that.$router.push({
                                        path: '/staff/approval'
                                    })
                                }
                            });
                        })
                }


            },
            entityShow() {//选择业务实体部分
                let that = this
                that.getOuByCus()//erp信息-获取业务实体
                that.entIndex = 1
                that.erp.entityPopShow = true
            }
            ,
            entityCancel() {
                let that = this
                that.erp.entityPopShow = false
            }
            ,
            entityConfirm(values) {
                let that = this
                that.erp.entityValue = values.ouName
                that.erp.entityId = values.orgId
                that.erp.entityPopShow = false
                that.entIndex = 2
                that.orgIndex = 2
            }
            ,
            entityChange(picker, values) {
                let that = this
                that.org.value = ''
                that.dec.value = ''
                that.sec.value = ''
                that.odt.value = ''
                that.jmb.value = ''
                //that.ptm.value = ''
                that.erp.jamubiao = false
                picker.setColumnValues(1, values.ouName)
            }
            ,
            orgShow() {//选择业务库部分
                let that = this
                that.$api.post(that.jumuc.userCenter.getOrgByOuId,
                    {"ouId": that.erp.entityId},
                    successRes => {
                        that.org.columns = JSON.parse(successRes.data).data
                    })
                that.org.popShow = true
            }
            ,
            orgCancel() {
                let that = this
                that.org.popShow = false
            }
            ,
            orgConfirm(values) {
                let that = this
                that.org.value = values.organizationName
                that.org.id = values.organizationId
                that.org.popShow = false
                that.entIndex = 3
            }
            ,
            orgChange(picker, values) {
                let that = this
                that.dec.value = ''
                that.sec.value = ''
                picker.setColumnValues(1, values.organizationName)
            }
            ,
            decShow() {//选择发运方式部分
                let that = this
                that.$api.post(that.jumuc.userCenter.getShimpmenthodEc,
                    {"organizationId": that.org.id},
                    successRes => {
                        that.dec.columns = JSON.parse(successRes.data).data
                    })
                that.dec.popShow = true
            }
            ,
            decCancel() {
                let that = this
                that.dec.popShow = false
            }
            ,
            decConfirm(values) {
                let that = this
                that.dec.value = values.shipMethodMeaning
                that.dec.id = values.carrierId
                that.dec.code = values.shipMethodCode
                that.dec.popShow = false
                that.entIndex = 4
            }
            ,
            decChange(picker, values) {
                let that = this
                that.sec.columns = []
                that.sec.value = ''
                picker.setColumnValues(1, values.shipMethodMeaning)
            }
            ,
            secShow() {//选择承运人部分
                let that = this
                that.$api.post(that.jumuc.userCenter.getCarriersEc,
                    {"organizationId": that.org.id, "carrierId": that.dec.id},
                    successRes => {
                        that.sec.columns = JSON.parse(successRes.data).data
                    })
                that.sec.popShow = true
            }
            ,
            secCancel() {
                let that = this
                that.sec.popShow = false
            }
            ,
            secConfirm(values) {
                let that = this
                that.sec.value = values.carrierName
                that.sec.id = values.carrierId
                that.sec.code = values.freightCode
                that.sec.popShow = false
                that.entIndex = 5
            }
            ,
            secChange(picker, values) {
                picker.setColumnValues(1, values.carrierName)
            }
            ,
            odtShow() {//选择订单类型部分
                let that = this
                that.$api.post(that.jumuc.userCenter.getOrderTypeListByOuId,
                    {"ouId": that.erp.entityId, "typeCode": 'ORDER'},
                    successRes => {
                        that.odt.columns = JSON.parse(successRes.data).data
                    })
                that.odt.popShow = true
            }
            ,
            odtCancel() {
                let that = this
                that.odt.popShow = false
            }
            ,
            odtConfirm(values) {
                let that = this
                that.odt.value = values.orderTypeName
                that.odt.id = values.orderTypeId
                that.odt.popShow = false
                that.entIndex = 6
            }
            ,
            odtChange(picker, values) {
                picker.setColumnValues(1, values.orderTypeName)
            }
            ,
            jmbShow() {//价目表部分
                let that = this
                that.$api.post(that.jumuc.userCenter.getPriceListByOuIdAndOrderId,
                    {"ouId": that.erp.entityId, "workFlowId": that.workFlow.id},
                    successRes => {
                        that.jmb.columns = JSON.parse(successRes.data).data
                    })
                that.jmb.popShow = true
            }
            ,
            jmbCancel() {
                let that = this
                that.jmb.popShow = false
            }
            ,
            jmbConfirm(values) {
                let that = this
                that.jmb.value = values.name
                that.jmb.id = values.listHeaderId
                that.jmb.popShow = false
                that.entIndex = 7
                localStorage.setItem('jmbid', values.listHeaderId)

            }
            ,
            jmbChange(picker, values) {
                picker.setColumnValues(1, values.name)
            }
            ,
            ptmShow() {//选择付款条件部分
                let that = this
                that.$api.post(that.jumuc.userCenter.getPaymentTerm,
                    null,
                    successRes => {
                        that.ptm.columns = JSON.parse(successRes.data).data
                    })
                that.ptm.popShow = true
            }
            ,
            ptmCancel() {
                let that = this
                that.ptm.popShow = false
            }
            ,
            ptmConfirm(values) {
                let that = this
                that.ptm.value = values.name
                that.ptm.id = values.paymentTermId
                that.ptm.popShow = false
                that.entIndex = 8
            }
            ,
            ptmChange(picker, values) {
                picker.setColumnValues(1, values.name)
            }
            ,
            ywyShow() {//选择业务编码部分
                let that = this
                that.ywy.columns = that.milkdeductamount.businessManUserCode.split(',')
                that.ywy.popShow = true
            }
            ,
            ywyCancel() {
                let that = this
                that.ywy.popShow = false
            }
            ,
            ywyConfirm(values) {
                let that = this
                that.ywy.value = values
                that.ywy.popShow = false
                that.entIndex = 9
            }
            ,
            ywyChange(picker, values) {
                picker.setColumnValues(1, values)
            }
            ,
            getPhone() {//根据车牌号获取手机号
                let that = this
                that.$api.post(that.jumuc.userCenter.getDriver,
                    {"carNumber": that.cheCode},
                    successRes => {
                        that.phone = successRes.data.driver_mobile
                        that.cheCode = successRes.data.driver_car_number
                        that.driverName = successRes.data.driver_name
                        that.driverIdnumber = successRes.data.driver_idnumber
                    })
            }
            ,
            changeYouJi() {//变更为邮寄
                let that = this
                that.$api.post(that.jumuc.userCenter.changeTransport,
                    {"id": that.workFlow.id},
                    successRes => {
                        if (successRes.success) {
                            that.changeShow = true
                        }
                    })
            }
            ,
            changeWorkFlowType() {//变更为非入库流程
                let that = this
                if (JSON.parse(localStorage.getItem("resultCheck")).length == 0) {
                    that.$toast("请在商品信息选择需要变更商品");
                } else {
                    Dialog.confirm({
                        title: '变更为非入库流程',
                        message: '确认提交吗？'
                    }).then(() => {
                        that.$api.post(that.jumuc.userCenter.changeWorkFlowType,
                            {
                                "workflowId": that.workFlow.id,
                                "goodsIds": JSON.parse(localStorage.getItem("resultCheck"))
                            },
                            successRes => {
                                that.$toast(successRes.msg);
                                that.$router.go(0)
                                that.tabActive = 2
                            })
                    })
                }
            }
            ,
            changeToBatchOut() {//超市分批
                let that = this
                that.$api.post(that.jumuc.userCenter.changeToBatchOut,
                    {"id": that.workFlow.id},
                    successRes => {
                        that.$toast(successRes.msg);
                        this.$router.go(0)
                    })
            }
            ,
            setBatchOutComplete() {//已全部出库
                let that = this
                that.$api.post(that.jumuc.userCenter.setBatchOutComplete,
                    {
                        "workflowId": that.workFlow.id,
                        "squence": that.workFlow.currentSquence,
                        "useridDeal": localStorage.getItem("userId"),
                        "remark": that.stockremark
                    },
                    successRes => {
                        if (successRes.success) {
                            that.$router.push({
                                path: '/staff/approval'
                            })
                        } else {
                            that.$toast(successRes.msg);
                        }
                    })
            }
            ,
            orderGoodsGiveSave() {//设置商品赠送数
                let that = this
                that.$router.push({
                    path: '/user/order/deliver-goods-num',
                    query: {
                        id: that.workFlow.id,
                        type: 'zs'
                    }
                })
            }
            ,
            syjmb(checked) {//是否使用价目价格
                let that = this
                if (checked && that.jmb.value == '') {
                    that.$toast('请选择价目表');
                    that.erp.jamubiao = false
                }
                if (that.failCode != '') {
                    Dialog.alert({
                        title: '',
                        message: '出库编码' + that.failCode + '的商品没有在该价目表中，如需使用价目表价格请将商品维护到该价目表中'
                    }).then(() => {
                        that.erp.jamubiao = false
                    });
                }
                if (that.jmb.value != '') {
                    localStorage.setItem('isjmbid', checked)
                }

            }
            ,
            fefundShowd() {//选择订单类型部分退货
                let that = this
                that.$api.post(that.jumuc.userCenter.getReturnReason,
                    null,
                    successRes => {
                        that.fefund.columnsd = JSON.parse(successRes.data).data
                    })
                that.fefund.popShowd = true
            }
            ,
            fefundCanceld() {
                let that = this
                that.fefund.popShowd = false
            }
            ,
            fefundtConfirmd(values) {
                let that = this
                that.fefund.valued = values.meaning
                that.fefund.idd = values.lookupCode
                that.fefund.popShowd = false
            }
            ,
            fefundChanged(picker, values) {
                picker.setColumnValues(1, values.meaning)
            }
            ,
            fefundShow() {//选择退货原因
                let that = this
                that.$api.post(that.jumuc.userCenter.getOrderTypeListByOuId,
                    {"ouId": that.data.erpinfoList[0].cuxOu, "typeCode": 'RETURN'},
                    successRes => {
                        that.fefund.columns = JSON.parse(successRes.data).data
                    })
                that.fefund.popShow = true
            }
            ,
            fefundCancel() {
                let that = this
                that.fefund.popShow = false
            }
            ,
            fefundtConfirm(values) {
                let that = this
                that.fefund.value = values.orderTypeName
                that.fefund.id = values.orderTypeId
                that.fefund.popShow = false
            }
            ,
            fefundChange(picker, values) {
                picker.setColumnValues(1, values.orderTypeName)
            }
            ,
            getIsNotNull() {//同步erp 审核通过接口参数封装
                let that = this
                that.isNotNull = ''


                //本次订单扣减奶款
                that.erpJson['finalDeductAmount'] = that.sumPrice

                if (that.erp.entityId == '') { //业务实体id
                    that.isNotNull = '业务实体id不能为空';
                    return false
                }
                that.erpJson['cuxOu'] = that.erp.entityId

                if (that.erp.entityValue == '') { //业务实体名称
                    that.isNotNull = '业务实体名称不能为空';
                    return false
                }
                that.erpJson['cuxOuName'] = that.erp.entityValue

                if (that.org.id == '') { //库id
                    that.isNotNull = '业务库不能为空';
                    return false
                }
                that.erpJson['warehouseId'] = that.org.id

                if (that.org.value == '') { //库名称
                    that.isNotNull = '业务库名称不能为空';
                    return false
                }
                that.erpJson['warehouseName'] = that.org.value

                // if (that.dec.code == '') { //发运方式
                //     that.isNotNull = '发运方式不能为空';
                //     return false
                // }
                that.erpJson['shippingMethodCode'] = that.dec.code

                // if (that.sec.code == '') { //承运人
                //     that.isNotNull = '承运人不能为空';
                //     return false
                // }
                that.erpJson['freightCarrierCode'] = that.sec.code

                if (that.odt.value == '') { //订单类型名称
                    that.isNotNull = '订单类型名称不能为空';
                    return false
                }
                that.erpJson['businessTypeName'] = that.odt.value

                if (that.odt.id == '') { //订单类型id
                    that.isNotNull = '订单类型id不能为空';
                    return false
                }
                that.erpJson['businessType'] = that.odt.id

                if (that.jmb.value == '') { //价目表名称
                    that.isNotNull = '价目表名称不能为空';
                    return false
                }
                that.erpJson['priceListName'] = that.jmb.value

                if (that.jmb.id == '') { //价目表id
                    that.isNotNull = '价目表id不能为空';
                    return false
                }
                that.erpJson['priceListId'] = that.jmb.id

                if (that.ptm.value == '') { //付款条件名称
                    that.isNotNull = '付款条件名称不能为空';
                    return false
                }
                that.erpJson['paymentTermName'] = that.ptm.value

                if (that.ptm.id == '') { //付款条件id
                    that.isNotNull = '付款条件id不能为空';
                    return false
                }
                that.erpJson['paymentTerm'] = that.ptm.id

                if (that.ywy.value == '') { //业务员编码
                    that.isNotNull = '业务员编码不能为空';
                    return false
                }
                that.erpJson['bmUserCode'] = that.ywy.value

                /* if (that.fhInfo == '') { //发货信息补充
                     that.isNotNull = '发货信息补充不能为空';
                     return false
                 }*/
                that.erpJson['shipInfo'] = that.fhInfo

                let goodcode = JSON.parse(localStorage.getItem("goodgys"))
                let str = ''
                for (var i = 0; i < goodcode.length; i++) {
                    if (i == goodcode.length) {
                        str = str + goodcode[i]
                    } else {
                        str = str + goodcode[i] + ","
                    }
                }
                if (str == '') { //供应商id
                    that.isNotNull = '供应商id不能为空';
                    return false
                }
                that.erpJson['supplerCode'] = str


                let gz = JSON.parse(localStorage.getItem("goodRule"))
                let syncJxcCode = ''
                let syncErpCode = ''
                for (var i = 0; i < gz.length; i++) {
                    if (gz[i].id == 1) {//同步进销存
                        syncJxcCode = syncJxcCode + gz[i].code + ','
                    }
                    if (gz[i].id == 2) {//同步ERP
                        syncErpCode = syncErpCode + gz[i].code + ','
                    }
                }
                if (syncJxcCode != '') {
                    syncJxcCode = syncJxcCode.substring(0, syncJxcCode.length - 1)
                }
                if (syncErpCode != '') {
                    syncErpCode = syncErpCode.substring(0, syncErpCode.length - 1)
                }
                that.erpJson['syncJxcCode'] = syncJxcCode //同步进销存
                that.erpJson['syncErpCode'] = syncErpCode //同步ERP

                that.erpJson['sourceTypeCode'] = that.sourceTypeCode //销转采订单

            }
            ,
            getJxC() {
                let that = this
                let goodcode = JSON.parse(localStorage.getItem("goodgys"))
                let str = ''
                for (var i = 0; i < goodcode.length; i++) {
                    if (i == goodcode.length) {
                        str = str + goodcode[i]
                    } else {
                        str = str + goodcode[i] + ","
                    }
                }
                if (str == '') { //供应商id
                    that.isNotNull = '供应商id不能为空';
                    return false
                }
                that.erpJson['supplerCode'] = str


                let gz = JSON.parse(localStorage.getItem("goodRule"))
                let syncJxcCode = ''
                let syncErpCode = ''
                for (var i = 0; i < gz.length; i++) {
                    if (gz[i].id == 1) {//同步进销存
                        syncJxcCode = syncJxcCode + gz[i].code + ','
                    }
                    if (gz[i].id == 2) {//同步ERP
                        syncErpCode = syncErpCode + gz[i].code + ','
                    }
                }
                if (syncJxcCode != '') {
                    syncJxcCode = syncJxcCode.substring(0, syncJxcCode.length - 1)
                }
                if (syncErpCode != '') {
                    syncErpCode = syncErpCode.substring(0, syncErpCode.length - 1)
                }
                that.erpJson['syncJxcCode'] = syncJxcCode //同步进销存
                that.erpJson['syncErpCode'] = syncErpCode //同步ERP
            }, isNotNullBus() {
                return false
                let that = this
                if (that.cheCode == null || that.cheCode == '') {
                    that.$toast('请输入车牌号')
                    return true
                }
                if (that.phone == null || that.phone == '') {
                    that.$toast('请输入司机手机号')
                    return true
                }
                if (that.birthday == null || that.birthday == '') {
                    that.$toast('请输入发车时间')
                    return true
                }

                if (that.driverName == null || that.driverName == '') {
                    that.$toast('请输入司机姓名')
                    return true
                }

                if (that.driverIdnumber == null || that.driverIdnumber == '') {
                    that.$toast('请输入司机身份证号')
                    return true
                }
                return false
            },
            getspeedy_input() {
                let that = this
                that.speedy_input = that.speedy_input.replace(/，|,/g, ",")
                let arry = []
                arry = that.speedy_input.split(",");
                that.cheCode = arry[2]
                that.birthday = arry[4]
                that.phone = arry[1]
                that.driverName = arry[0]
                that.driverIdnumber = arry[3]
            },
            seeIsTrueOrder() {
                let that = this
                that.$router.push({
                    path: '/user/order/arrival',
                    query: {
                        id: that.order.id
                    }
                })
            }
        }, filters: {
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2)
                return realVal
            }
        },
    }
    ;
</script>
<style lang="less">
    @bule-thame: #3C6EEB;

    body {
        background: #f7f7ff;
    }

    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
        min-width: 80px;
        left: -10px;
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }

    .jump-warphd {

        /*.van-icon {
            color: @bule-thame;
        }*/
        .appr-item {
            padding: 10px;
            margin-bottom: 10px;
            background-color: #fff;
            h5 {
                font-size: 16px;
                padding-bottom: 10px;
                i {
                    padding: 5px;
                    background-color: @bule-thame;
                    color: #fff;
                    border-radius: 100%;
                    margin-right: 5px;
                }
            }
            p {
                padding: 4px 0;
                font-size: 14px;
                &.item-r {
                    color: #ccc;
                    text-align: right;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
            }
            &-head {
                border-bottom: 1px #f7f7f7 solid;
                &-hd {
                    position: relative;
                }
            }
            &-foot {
                border-top: 1px #f7f7f7 solid;
                p {
                    color: #ccc
                }
            }
            .item-arrow {
                border-top: 1px solid #f7f7f7;
                text-align: center;
                color: @bule-thame;
            }
            .line {
                display: block;
                border-bottom: 1px solid #f7f7f7;
            }
        }
        .appr-item:last-child {
            margin-bottom: 0px !important;
        }
        .pro-body {
            padding: 10px;
            .pro-item {
                margin-bottom: 10px;
                background-color: #fff;
                padding: 10px;
                h5 {
                    font-size: 14px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #f7f7f7;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
                p {
                    font-size: 14px;
                    padding: 10px 0;
                }
                &-by {
                    padding: 10px 0 0;
                }
                &-ft {
                    background-color: #f7f7f7;
                    padding: 10px;
                }
                .pro-edit {
                    color: @bule-thame;
                    text-decoration: underline;
                    i {
                        vertical-align: -2px;
                    }
                }
            }
        }
        .pay-by {
            padding: 10px;
            .pay-item {
                background-color: #fff;
                padding: 10px;
                position: relative;
                margin-bottom: 10px;
                p {
                    color: #ccc;
                    font-size: 12px;
                    padding: 5px 0;
                }
                &-ft {
                    padding-top: 10px;
                    p {
                        color: #333;
                    }
                }
                .pay-state {
                    text-align: right;
                    color: @bule-thame;
                    i {
                        display: inline-block;
                        padding: 5px;
                        border-radius: 100%;
                        background-color: @bule-thame;
                    }
                }
                &-rd {
                    position: absolute;
                    top: 0;
                    left: -5px;
                    width: 10px;
                    height: 100%;
                    background-color: @bule-thame;
                    border-radius: 10px 0 0 10px;
                }

                &.ok {
                    .pay-state {
                        color: #28a745;
                        i {
                            background-color: #28a745;
                        }
                    }
                    .pay-item-rd {
                        background-color: #28a745;
                    }
                }
                &.err {
                    .pay-state {
                        color: #ffc107;
                        i {
                            background-color: #ffc107;
                        }
                    }
                    .pay-item-rd {
                        background-color: #ffc107;
                    }
                }
            }
        }
        .pay-hd-item {
            margin-bottom: 10px;
            .pay-hd-line {
                border-bottom: 1px solid #f7f7f7;
                margin-bottom: 10px;
            }
            .van-field {
                border: 1px solid #f7f7f7;
            }
        }

        .van-cell:not(:last-child)::after {
            border: none;
        }

        .apply {
            .van-field {
                margin: 10px 0;
                border: 1px solid #f7f7f7;
            }
            .van-col--8 {
                padding: 0 10px;
            }
            button {
                font-size: 14px;
                height: 40px;
                line-height: 38px;
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
            button.danger {
                background-color: #ffc107;
                border-color: #ffc107;
            }
            button.blues {
                background-color: #007bff;
                border-color: #007bff;
            }
        }

        .item-body-warp {
            height: 60px;
            overflow: hidden;
            position: relative;
        }
        .item-body-warp.open {
            height: auto;
        }
    }

    .delete {
        font-size: 28px;
        position: absolute;
        margin-left: 25%;
    }
</style>
